
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("lwfLq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jSpMW = parcelRequire("jSpMW");


var $gdv5Z = parcelRequire("gdv5Z");


var $a48Rq = parcelRequire("a48Rq");


var $1sDXW = parcelRequire("1sDXW");

const $9a1f3bb72a598050$var$styles = {
    animationContainer: "_1e0cglyw _dm251ule _13wnstnw _1sbqidpf _bjm4idpf _1xkaidpf _1r6vidpf _hyzqidpf _1qbjglyw _glte1qhy"
};

const $9a1f3bb72a598050$var$loadLightAnimation = ()=>{
    return (parcelRequire("7sl9l"));
};

const $9a1f3bb72a598050$var$loadDarkAnimation = ()=>{
    return (parcelRequire("kOxmL"));
};
const $9a1f3bb72a598050$export$7ec1bc985584df4b = ({ onComplete: onComplete, onErrorLoadingAnimation: onErrorLoadingAnimation })=>{
    const animationData = (0, $a48Rq.useThemeAnimation)($9a1f3bb72a598050$var$loadLightAnimation, $9a1f3bb72a598050$var$loadDarkAnimation, onErrorLoadingAnimation);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $9a1f3bb72a598050$var$styles.animationContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1sDXW.Skeleton), {
            isLoading: !animationData,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSpMW))), {
                animationData: animationData,
                onComplete: onComplete,
                loop: false,
                autoplay: true
            })
        })
    });
};
module.exports["WelcomeAnimation"] = $9a1f3bb72a598050$export$7ec1bc985584df4b;

});

parcelRegister("7sl9l", function(module, exports) {

let $56db8dd209e85ec5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56db8dd209e85ec5$var$load("8Y9rK").then(()=>parcelRequire('k130t'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("kOxmL", function(module, exports) {

let $f2725bf577e488fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2725bf577e488fe$var$load("l1BtG").then(()=>parcelRequire('cDM7M'));

});

parcelRegister("jO0hz", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $cOrQJ = parcelRequire("cOrQJ");

const $27ab1c023dc72179$var$styles = {
    container: "_1reo15vq _18m915vq _kqswh2mm _1bsb1osq _4t3i1osq",
    background: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1pbykb7n",
    content: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1pbyb4wl _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
};
const $27ab1c023dc72179$var$Background = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $27ab1c023dc72179$var$styles.background,
        children: children
    });
const $27ab1c023dc72179$var$Content = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $27ab1c023dc72179$var$styles.content,
        children: children
    });
const $27ab1c023dc72179$export$dd9bb3a4e1cb3795 = ({ children: children, testId: testId, ModalBackgroundLight: ModalBackgroundLight, ModalBackgroundDark: ModalBackgroundDark })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $27ab1c023dc72179$var$styles.container,
        testId: testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundImage: ModalBackgroundLight && ModalBackgroundDark ? `url(${isDarkMode ? ModalBackgroundDark : ModalBackgroundLight})` : undefined
        },
        children: children
    });
};
$27ab1c023dc72179$export$dd9bb3a4e1cb3795.Background = $27ab1c023dc72179$var$Background;
$27ab1c023dc72179$export$dd9bb3a4e1cb3795.Content = $27ab1c023dc72179$var$Content;
module.exports["ScreenLayout"] = $27ab1c023dc72179$export$dd9bb3a4e1cb3795;

});

parcelRegister("9ak6Q", function(module, exports) {
const $88f435443d68352e$export$bc4310477dcd6b19 = {
    ATLASSIAN_SWITCHER: 'atlassianSwitcher',
    TOWNSQUARE_TWC_XFLOW_MODAL: 'townsquareTwcXflowModal',
    TOWNSQUARE_TWC_XFLOW_MODAL_V2: 'townsquareTwcXflowModalV2',
    TWC_LT_BANNER: 'teamworkCollectionLtBanner',
    STORYBOOK: 'storybook',
    TEST: 'test'
};
const $88f435443d68352e$export$1b7797189cccf3b2 = {
    ATLASSIAN_SWITCHER_TRY: 'atlassianSwitcherTry',
    SCREEN_SPACE_FLAGS: 'postOfficeScreenSpaceFlagsPlacement',
    TOWNSQUARE_SCREEN_SPACE_FLAGS: 'postOfficeTownsquareScreenSpaceFlagsPlacement',
    TWC_LT_BANNER_TRY_NOW: 'teamworkCollectionLtBannerTryNow',
    STORYBOOK: 'storybook',
    TEST: 'test'
};
module.exports["SOURCE_COMPONENT"] = $88f435443d68352e$export$bc4310477dcd6b19;
module.exports["SOURCE_CONTEXT"] = $88f435443d68352e$export$1b7797189cccf3b2;

});

parcelRegister("62Hqv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cac346414ecddf4$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $8CZUH = parcelRequire("8CZUH");

var $6xdDU = parcelRequire("6xdDU");


var $dh538 = parcelRequire("dh538");


var $bedQP = parcelRequire("bedQP");


var $gdv5Z = parcelRequire("gdv5Z");


var $kDHbX = parcelRequire("kDHbX");




const $c175f2a7ad162fe0$var$XFLOW_SERVICE_URL = '/gateway/api/xflow/provision/cloud';
const $c175f2a7ad162fe0$export$a954a840fe6f9c7e = async ({ cloudId: cloudId, signal: signal })=>{
    try {
        const response = await fetch(`${$c175f2a7ad162fe0$var$XFLOW_SERVICE_URL}/${encodeURIComponent(cloudId)}/product/teamwork-collection/job/nth-user-access/start`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({}),
            signal: signal
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    } catch (error) {
        (0, $kDHbX.captureException)('Failed to start normalize seat job', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
        throw error;
    }
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


const $c7f0819402fcc1f3$var$ModalContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $c7f0819402fcc1f3$export$178405afcd8c5eb = $c7f0819402fcc1f3$var$ModalContext.Provider;
const $c7f0819402fcc1f3$export$4cc1699d46f42cae = ()=>{
    const ctx = (0, $42omo.useContext)($c7f0819402fcc1f3$var$ModalContext);
    if (!ctx) throw new Error('useModalContext must be used within ModalProvider');
    return ctx;
};
const $c7f0819402fcc1f3$export$baa48889c42cc6cb = (cloudId, sourceComponent, sourceContext, locale, orgId, presets)=>{
    const [currentScreen, setCurrentScreen] = (0, $42omo.useState)(presets?.initialScreen ?? 'loading');
    const [redirectUrl, setRedirectUrl] = (0, $42omo.useState)(presets?.initialRedirectUrl ?? 'https://home.atlassian.com/');
    const [modalState, setModalState] = (0, $42omo.useState)(()=>({
            edition: 'premium',
            hasPaymentDetails: true,
            userProducts: [],
            priceSegmentation: 'increase',
            priceValue: undefined,
            activationCapability: 'can-activate',
            ...presets?.initialModalState
        }));
    const [isNormalizeSeatsEnabled, setIsNormalizeSeatsEnabled] = (0, $42omo.useState)(presets?.initialIsNormalizeSeatsEnabled ?? true);
    const contextValue = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            locale: locale,
            sourceComponent: sourceComponent,
            sourceContext: sourceContext,
            currentScreen: currentScreen,
            setCurrentScreen: setCurrentScreen,
            modalState: modalState,
            setModalState: setModalState,
            orgId: orgId,
            redirectUrl: redirectUrl,
            setRedirectUrl: setRedirectUrl,
            isNormalizeSeatsEnabled: isNormalizeSeatsEnabled,
            setIsNormalizeSeatsEnabled: setIsNormalizeSeatsEnabled
        }), [
        cloudId,
        locale,
        sourceComponent,
        sourceContext,
        currentScreen,
        modalState,
        orgId,
        redirectUrl,
        isNormalizeSeatsEnabled
    ]);
    return contextValue;
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 






var $gtD4K = parcelRequire("gtD4K");







var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $lAFHW = parcelRequire("lAFHW");


var $8TTLA = parcelRequire("8TTLA");




var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

var $04baef9fdbf74f8c$exports = {};
$04baef9fdbf74f8c$exports = new URL("confirmationBackgroundV2.dark.7c389c39.png", import.meta.url).toString();


var $2ae1aab4f6bcae8b$exports = {};
$2ae1aab4f6bcae8b$exports = new URL("confirmationBackgroundV2.light.74baa5b8.png", import.meta.url).toString();


var $b5d80395174c93b0$exports = {};
$b5d80395174c93b0$exports = new URL("confirmationVisual.dark.3beace2d.svg", import.meta.url).toString();


var $d1800ff4524f9f89$exports = {};
$d1800ff4524f9f89$exports = new URL("confirmationVisual.light.4c2dbe9e.svg", import.meta.url).toString();


var $ba00c4af743cca2a$exports = {};
$ba00c4af743cca2a$exports = new URL("teamworkCollectionHeaderV2.dark.88afbace.png", import.meta.url).toString();


var $a1ea08d599f9bd15$exports = {};
$a1ea08d599f9bd15$exports = new URL("teamworkCollectionHeaderV2.light.d5af8710.png", import.meta.url).toString();


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $2Nwuj = parcelRequire("2Nwuj");







var $cgtv4 = parcelRequire("cgtv4");

const $5a159d476d11f1ed$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noPaymentDetailsLegalTextStandard: {
        id: "twc.xflow.modal.legal.noPaymentDetailsLegalTextStandard.v2",
        defaultMessage: "Cancel anytime. By selecting \"{cta}\" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>"
    },
    noPaymentDetailsLegalTextPremium: {
        id: "twc.xflow.modal.legal.noPaymentDetailsLegalTextPremium.v2",
        defaultMessage: "Cancel anytime. By selecting \"{cta}\" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>"
    },
    paymentDetailsLegalText: {
        id: "twc.xflow.modal.legal.paymentDetailsLegalText.v2",
        defaultMessage: "By selecting \"{cta}\" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp> {br}If you don't cancel during the trial, subscription billing will begin and renew monthly based on pricing of Teamwork Collection. Cancel anytime.{br}"
    }
});


const $4901062e92c1b766$var$URLS = {
    TERMS: 'https://www.atlassian.com/legal/customer-agreement',
    PRIVACY: 'https://www.atlassian.com/legal/privacy-policy'
};
const $4901062e92c1b766$export$fc21a04a622ec81e = ({ ctaText: ctaText, edition: edition, hasPaymentDetails: hasPaymentDetails })=>{
    const noPaymentDetailsLegalText = edition === 'premium' ? (0, $5a159d476d11f1ed$export$defe85febe8b728c).noPaymentDetailsLegalTextPremium : (0, $5a159d476d11f1ed$export$defe85febe8b728c).noPaymentDetailsLegalTextStandard;
    const legalText = hasPaymentDetails ? (0, $5a159d476d11f1ed$export$defe85febe8b728c).paymentDetailsLegalText : noPaymentDetailsLegalText;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            weight: "regular",
            color: "color.text.subtlest",
            testId: "legal-text",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...legalText,
                values: {
                    cta: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...ctaText
                    }),
                    tc: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            href: $4901062e92c1b766$var$URLS.TERMS,
                            target: "_blank",
                            children: chunks
                        }),
                    pp: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            href: $4901062e92c1b766$var$URLS.PRIVACY,
                            target: "_blank",
                            children: chunks
                        }),
                    br: /*#__PURE__*/ (0, $l998X.jsx)("br", {})
                }
            })
        })
    });
};



var $jO0hz = parcelRequire("jO0hz");



var $cOrQJ = parcelRequire("cOrQJ");

const $0fd45bf3f75c7971$export$c720381daa58fcbb = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return colorMode === 'dark';
};





const $67f905b5cc424541$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    headingNoPriceIncrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.no.price.increase",
        defaultMessage: "Accelerate teamwork 3\xD7 faster with video and AI, at {headingEmphasis}"
    },
    headingNoPriceIncreaseEmphasis: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.no.price.increase.emphasis.ai.powered",
        defaultMessage: "no added cost"
    },
    headingPriceIncrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.price.increase",
        defaultMessage: "Accelerate teamwork {headingEmphasis} with {break}"
    },
    headingJiraOnly: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.jira.only",
        defaultMessage: "Accelerate teamwork {headingEmphasis} with {break}"
    },
    headingJiraAndLoom: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.jira.and.loom",
        defaultMessage: "Accelerate teamwork {headingEmphasis} with {break}"
    },
    headingPriceIncreaseEmphasis: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.price.increase.emphasis",
        defaultMessage: "3\xD7 faster"
    },
    headingAIPowered: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.ai.powered",
        defaultMessage: "AI-powered collaboration"
    },
    headingVideo: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.video",
        defaultMessage: "video and AI-powered collaboration"
    },
    headingDocs: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.docs",
        defaultMessage: "docs and AI-powered collaboration"
    },
    closeModal: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.close",
        defaultMessage: "Close modal"
    },
    teamworkCollectionAlt: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.alt",
        defaultMessage: "Teamwork collection illustration"
    },
    ctaWithPaymentDetailsOnFile: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.ctaWithPaymentDetailsOnFile",
        defaultMessage: "Agree and start trial"
    },
    ctaNoPaymentDetailsOnFile: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.ctaNoPaymentDetailsOnFile",
        defaultMessage: "Next"
    },
    trialTextStandardNoPriceIncrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.standard.noPriceIncrease",
        defaultMessage: "14-day free trial. After, your cost will {priceChange}."
    },
    trialTextPremiumNoPriceIncrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.premium.noPriceIncrease",
        defaultMessage: "30-day free trial. After, your cost will {priceChange}."
    },
    priceChangeSame: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.noPriceIncrease.same",
        defaultMessage: "stay the same"
    },
    priceChangeDecrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.noPriceIncrease.decrease",
        defaultMessage: "decrease"
    },
    trialTextStandardPriceIncrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.standard.priceIncrease",
        defaultMessage: "14-day free trial of Standard plan"
    },
    requestTrialText: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.request.trial",
        defaultMessage: "Request approval from your admin to try Teamwork Collection"
    },
    ctaRequestTrialText: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.cta.request.trial",
        defaultMessage: "Request to try"
    },
    requestTrialComment: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.request.trial.comment",
        defaultMessage: "Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams\u2014all in one place."
    },
    trialTextPremiumPriceIncrease: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.premium.priceIncrease",
        defaultMessage: "30-day free trial of Premium plan"
    },
    descriptionConfluence: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.confluence",
        defaultMessage: "Create and collaborate on docs seamlessly"
    },
    descriptionRovo: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.rovo",
        defaultMessage: "Easily find answers and create with AI"
    },
    descriptionLoomStandard: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.loom",
        defaultMessage: "Save time by sharing videos your team can replay anytime"
    },
    descriptionLoomPremium: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.loom",
        defaultMessage: "Save time with AI-generated meeting notes and video"
    },
    existingAppsHeader: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.existing.apps.header",
        defaultMessage: "Bundled with your existing {appCount, plural, one {app} other {apps}}"
    },
    visualAlt: {
        id: "twc.xflow.modal.teamwork.collection.confirmation.screen.v2.visual.alt",
        defaultMessage: "A graphic that displays Jira, Confluence, Confluence, and Loom integrations"
    }
});


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
const $ef4fe03c7f79a37a$export$e66a4b22677eb5fd = (priceSegmentation, userProducts)=>{
    const hasJira = userProducts.includes('jira');
    const hasConfluence = userProducts.includes('confluence');
    if (priceSegmentation !== 'increase' && hasJira && hasConfluence) return {
        message: (0, $67f905b5cc424541$export$defe85febe8b728c).headingNoPriceIncrease,
        noAddedCost: true
    };
    const hasLoom = userProducts.includes('loom');
    if (hasJira && hasLoom && userProducts.length === 2) return {
        message: (0, $67f905b5cc424541$export$defe85febe8b728c).headingJiraAndLoom,
        headingBreak: (0, $67f905b5cc424541$export$defe85febe8b728c).headingDocs
    };
    if (hasJira && userProducts.length === 1) return {
        message: (0, $67f905b5cc424541$export$defe85febe8b728c).headingJiraOnly,
        headingBreak: (0, $67f905b5cc424541$export$defe85febe8b728c).headingAIPowered
    };
    return {
        message: (0, $67f905b5cc424541$export$defe85febe8b728c).headingPriceIncrease,
        headingBreak: (0, $67f905b5cc424541$export$defe85febe8b728c).headingVideo
    };
};


const $ac1e78a9b56061c3$var$styles = {
    content: "_1e0c1txw _2lx21bp4 _4t3i1osq _ca0q1ejb _19bv1ejb _u5f31ejb _oqicoahv _pnmboahv _1rmjoahv",
    cta: "_19pkv47k _16jlkb7n _1e0c1txw _2lx21bp4 _1bahesu3 _4cvrh9n0",
    closeButton: "_kqswstnw _154i1jfw _1xi21jfw _1sbqpxbi _1r6vpxbi",
    modalContent: "_2rko1mok _1e0c1txw _16jlkb7n _2lx2vrvc _bfhkhp5a",
    leftColumn: "_1e0c1txw _2lx21bp4 _16jlkb7n _ca0q1jfw _19bv1jfw _u5f3xy5q _n3td1jfw",
    rightColumn: "_1e0cglyw _1vdkidpf _dm251txw _oqicxy5q _pnmbxy5q _1rmjxy5q _cjbtxy5q",
    heading: "_19pk1ejb",
    headingEmphasis: "_11c81af2 _1e0c1nu9 _syaz1oa5 _o5721q9c",
    subheading: "_11c8wadc _19pk1b66",
    newApps: "_19pk1ejb",
    newApp: "_1e0c1txw _2lx2vrvc _4cvr1h6o _19pku2gc",
    newAppFirst: "_19pkidpf",
    newAppText: "_18u0utpp _1e0c1txw _2lx21bp4",
    existingAppsHeader: "_11c8wadc _19pk1ejb",
    existingAppsHeaderCompact: "_11c8wadc _19pkpxbi",
    existingApps: "_zulppxbi _1e0c1txw _2lx2vrvc",
    existingAppText: "_18u012x7",
    legalText: "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1tke8vuz _y3gn1h6o"
};
const $ac1e78a9b56061c3$var$productIdMapping = {
    confluence: {
        Icon: (0, $lAFHW.ConfluenceIcon),
        header: 'Confluence',
        descriptionStandard: (0, $67f905b5cc424541$export$defe85febe8b728c).descriptionConfluence,
        descriptionPremium: null
    },
    jira: {
        Icon: (0, $lAFHW.JiraIcon),
        header: 'Jira',
        descriptionStandard: null,
        descriptionPremium: null
    },
    rovo: {
        Icon: (0, $lAFHW.RovoIcon),
        header: 'Rovo',
        descriptionStandard: (0, $67f905b5cc424541$export$defe85febe8b728c).descriptionRovo,
        descriptionPremium: null
    },
    loom: {
        Icon: (0, $lAFHW.LoomIcon),
        header: 'Loom',
        descriptionStandard: (0, $67f905b5cc424541$export$defe85febe8b728c).descriptionLoomStandard,
        descriptionPremium: (0, $67f905b5cc424541$export$defe85febe8b728c).descriptionLoomPremium
    }
};
const $ac1e78a9b56061c3$export$88ff240c67647cf0 = ({ onTryNowClick: onTryNowClick, onClose: onClose, canActivate: canActivate, confirmationSubheader: confirmationSubheader, confirmationCtaText: confirmationCtaText })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isDarkMode = (0, $0fd45bf3f75c7971$export$c720381daa58fcbb)();
    const { modalState: modalState, sourceComponent: sourceComponent, sourceContext: sourceContext } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    const { userProducts: userProducts, hasPaymentDetails: hasPaymentDetails, edition: edition, priceSegmentation: priceSegmentation, priceValue: priceValue } = modalState;
    const handleTryNowClick = ()=>{
        onTryNowClick();
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalConfirmationScreenTryNow',
            attributes: {
                canActivate: canActivate,
                edition: edition,
                hasPaymentDetails: hasPaymentDetails,
                userProducts: userProducts,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    };
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalConfirmationScreen',
            attributes: {
                canActivate: canActivate,
                edition: edition,
                hasPaymentDetails: hasPaymentDetails,
                userProducts: userProducts,
                priceSegmentation: priceSegmentation,
                priceValue: priceValue,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        canActivate,
        edition,
        hasPaymentDetails,
        userProducts,
        priceSegmentation,
        priceValue,
        sourceComponent,
        sourceContext
    ]);
    const newApps = (0, $42omo.useMemo)(()=>{
        const eligibleApps = [
            'jira',
            'confluence',
            'loom',
            'rovo'
        ];
        return eligibleApps.filter((product)=>!userProducts.includes(product));
    }, [
        userProducts
    ]);
    const existingAppsToShow = (0, $42omo.useMemo)(()=>{
        if (!canActivate) {
            const eligibleApps = [
                'jira',
                'confluence',
                'loom',
                'rovo'
            ];
            return userProducts.filter((product)=>eligibleApps.includes(product));
        }
        return userProducts;
    }, [
        userProducts,
        canActivate
    ]);
    const heading = (0, $42omo.useMemo)(()=>(0, $ef4fe03c7f79a37a$export$e66a4b22677eb5fd)(priceSegmentation, userProducts), [
        priceSegmentation,
        userProducts
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout), {
        testId: "confirmation-screen-v2",
        ModalBackgroundDark: (0, (/*@__PURE__*/$parcel$interopDefault($04baef9fdbf74f8c$exports))),
        ModalBackgroundLight: (0, (/*@__PURE__*/$parcel$interopDefault($2ae1aab4f6bcae8b$exports))),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $ac1e78a9b56061c3$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $ac1e78a9b56061c3$var$styles.closeButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                        onClick: onClose,
                        label: formatMessage((0, $67f905b5cc424541$export$defe85febe8b728c).closeModal)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $ac1e78a9b56061c3$var$styles.modalContent,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            xcss: $ac1e78a9b56061c3$var$styles.leftColumn,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                    src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($ba00c4af743cca2a$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a1ea08d599f9bd15$exports))),
                                    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ba00c4af743cca2a$exports))),
                                    alt: formatMessage((0, $67f905b5cc424541$export$defe85febe8b728c).teamworkCollectionAlt),
                                    testId: "teamwork-collection-header-v2",
                                    width: "134",
                                    height: "32"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $ac1e78a9b56061c3$var$styles.heading,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                        size: "medium",
                                        testId: "modal-heading-v2",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...heading.message,
                                            values: {
                                                break: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...heading.headingBreak
                                                }),
                                                headingEmphasis: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                    xcss: $ac1e78a9b56061c3$var$styles.headingEmphasis,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...heading.noAddedCost ? (0, $67f905b5cc424541$export$defe85febe8b728c).headingNoPriceIncreaseEmphasis : (0, $67f905b5cc424541$export$defe85febe8b728c).headingPriceIncreaseEmphasis
                                                    })
                                                })
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $ac1e78a9b56061c3$var$styles.subheading,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        color: "color.text.subtle",
                                        testId: "modal-subheading-v2",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...confirmationSubheader
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $ac1e78a9b56061c3$var$styles.newApps,
                                    children: newApps.map((newApp, index)=>{
                                        const Icon = $ac1e78a9b56061c3$var$productIdMapping[newApp].Icon;
                                        const description = edition === 'premium' && $ac1e78a9b56061c3$var$productIdMapping[newApp].descriptionPremium || $ac1e78a9b56061c3$var$productIdMapping[newApp].descriptionStandard;
                                        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                            xcss: (0, $1Whri.cx)($ac1e78a9b56061c3$var$styles.newApp, index === 0 && $ac1e78a9b56061c3$var$styles.newAppFirst),
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                                                    shouldUseHexLogo: true,
                                                    appearance: "brand",
                                                    shouldUseNewLogoDesign: true,
                                                    size: "medium"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                    xcss: $ac1e78a9b56061c3$var$styles.newAppText,
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                            size: "xsmall",
                                                            children: $ac1e78a9b56061c3$var$productIdMapping[newApp].header
                                                        }),
                                                        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                            size: "small",
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                ...description
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, newApp);
                                    })
                                }),
                                existingAppsToShow.length > 0 ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: newApps.length > 2 ? $ac1e78a9b56061c3$var$styles.existingAppsHeaderCompact : $ac1e78a9b56061c3$var$styles.existingAppsHeader,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...(0, $67f905b5cc424541$export$defe85febe8b728c).existingAppsHeader,
                                                    values: {
                                                        appCount: existingAppsToShow.length
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $ac1e78a9b56061c3$var$styles.existingApps,
                                            children: existingAppsToShow.map((existingApp)=>{
                                                const Icon = $ac1e78a9b56061c3$var$productIdMapping[existingApp].Icon;
                                                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                    xcss: $ac1e78a9b56061c3$var$styles.newApp,
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                                                            appearance: "brand",
                                                            shouldUseHexLogo: true,
                                                            shouldUseNewLogoDesign: true,
                                                            size: "xsmall"
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: $ac1e78a9b56061c3$var$styles.existingAppText,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                                size: "xxsmall",
                                                                children: $ac1e78a9b56061c3$var$productIdMapping[existingApp].header
                                                            })
                                                        })
                                                    ]
                                                }, existingApp);
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $ac1e78a9b56061c3$var$styles.cta,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            appearance: "primary",
                                            onClick: handleTryNowClick,
                                            testId: "primary-cta-v2",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...confirmationCtaText
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $ac1e78a9b56061c3$var$styles.rightColumn,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($b5d80395174c93b0$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d1800ff4524f9f89$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b5d80395174c93b0$exports))),
                                alt: formatMessage((0, $67f905b5cc424541$export$defe85febe8b728c).visualAlt),
                                testId: "teamwork-collection-visual",
                                width: "345",
                                height: "400"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $ac1e78a9b56061c3$var$styles.legalText,
                    children: canActivate && /*#__PURE__*/ (0, $l998X.jsx)((0, $4901062e92c1b766$export$fc21a04a622ec81e), {
                        hasPaymentDetails: hasPaymentDetails,
                        edition: edition,
                        ctaText: confirmationCtaText
                    })
                })
            ]
        })
    });
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
















var $7p4As = parcelRequire("7p4As");








var $6f0Oj = parcelRequire("6f0Oj");


var $5dK2X = parcelRequire("5dK2X");

var $13484c3c3fe72b94$exports = {};
$13484c3c3fe72b94$exports = new URL("warning.f5011eb7.png", import.meta.url).toString();









const $a635e607a9944496$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    heading: {
        id: "twc.xflow.modal.error.heading",
        defaultMessage: "Looks like something went wrong"
    },
    description: {
        id: "twc.xflow.modal.error.description",
        defaultMessage: "We weren't able to start your trial. Try again later or contact our support team."
    },
    closeButton: {
        id: "twc.xflow.modal.error.close.button",
        defaultMessage: "Close"
    },
    contactSupportButton: {
        id: "twc.xflow.modal.error.contact.support.button",
        defaultMessage: "Contact support"
    },
    errorIconAlt: {
        id: "twc.xflow.modal.error.icon.alt",
        defaultMessage: "Error icon"
    }
});


const $5867abb547886a50$var$styles = {
    modalContent: "_2rko1mok _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _19pkoahv _18u0oahv _2hwxoahv _otyroahv _y3gn1h6o",
    iconWrapper: "_otyrpxbi _19pkxy5q _1e0c1txw _4cvr1h6o _1bah1h6o",
    heading: "_otyrpxbi",
    description: "_otyroahv _p12f1kdj",
    buttons: "_zulp1b66 _1e0c1txw"
};
const $5867abb547886a50$export$42f84e610f279c31 = ({ onClose: onClose })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalErrorScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    const handleContactSupportClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalErrorScreenContactSupport',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout), {
        testId: "error-screen",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout).Content, {
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                as: "div",
                xcss: $5867abb547886a50$var$styles.modalContent,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                        xcss: $5867abb547886a50$var$styles.iconWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($13484c3c3fe72b94$exports))),
                            width: 150,
                            height: 150,
                            testId: "error-icon",
                            alt: intl.formatMessage((0, $a635e607a9944496$export$defe85febe8b728c).errorIconAlt)
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                        xcss: $5867abb547886a50$var$styles.heading,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "medium",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $a635e607a9944496$export$defe85febe8b728c).heading
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                        xcss: $5867abb547886a50$var$styles.description,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "medium",
                            weight: "regular",
                            color: "color.text.subtlest",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $a635e607a9944496$export$defe85febe8b728c).description
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                        xcss: $5867abb547886a50$var$styles.buttons,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $a635e607a9944496$export$defe85febe8b728c).closeButton
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                appearance: "primary",
                                href: "https://support.atlassian.com/contact/#/",
                                target: "_blank",
                                onClick: handleContactSupportClick,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $a635e607a9944496$export$defe85febe8b728c).contactSupportButton
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 















var $kpYGL = parcelRequire("kpYGL");




/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ var $63b5dba8efa5d046$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["LOOM"] = "loom";
    ProductKey["ROVO"] = "rovo.ondemand";
    return ProductKey;
}({});


const $e9b1f63481f8c476$var$SUPPORTED_PRODUCTS = [
    (0, $63b5dba8efa5d046$export$f3a53bd43617a593).JIRA_SOFTWARE,
    (0, $63b5dba8efa5d046$export$f3a53bd43617a593).CONFLUENCE,
    (0, $63b5dba8efa5d046$export$f3a53bd43617a593).LOOM,
    (0, $63b5dba8efa5d046$export$f3a53bd43617a593).ROVO
];
const $e9b1f63481f8c476$var$PRODUCT_DISPLAY_NAME = {
    [(0, $63b5dba8efa5d046$export$f3a53bd43617a593).JIRA_SOFTWARE]: 'jira',
    [(0, $63b5dba8efa5d046$export$f3a53bd43617a593).CONFLUENCE]: 'confluence',
    [(0, $63b5dba8efa5d046$export$f3a53bd43617a593).LOOM]: 'loom',
    [(0, $63b5dba8efa5d046$export$f3a53bd43617a593).ROVO]: 'rovo'
};
const $e9b1f63481f8c476$export$870466e371fb4e1e = async (cloudId)=>{
    const response = await fetch(`/gateway/api/xflow/${cloudId}/license-information`);
    if (!response.ok) throw new Error(`Non-OK response when fetching license information: HTTP ${response.status}: ${response.statusText}`);
    const data = await response.json();
    return $e9b1f63481f8c476$var$SUPPORTED_PRODUCTS.filter((product)=>data.products[product]?.state === 'ACTIVE').map((product)=>$e9b1f63481f8c476$var$PRODUCT_DISPLAY_NAME[product]);
};



var $jjbGD = parcelRequire("jjbGD");








var $fFa3V = parcelRequire("fFa3V");

// to remove free after STARB-1521
class $1f028cc32ce8a67c$export$c7a4ee803115cfef extends Error {
    static is(error) {
        return error instanceof $1f028cc32ce8a67c$export$c7a4ee803115cfef || error instanceof Error && error.name === 'PollingTimeoutError' && 'maxDuration' in error;
    }
    constructor(maxDuration){
        super(`Polling timed out after ${maxDuration}ms`);
        this.maxDuration = void 0;
        this.name = 'PollingTimeoutError';
        this.maxDuration = maxDuration;
    }
}


async function $ee5ab9a47b321e93$export$e0c10349b2c5e1d4(fn, shouldContinue, options) {
    if (options.interval < 0 || options.maxDuration < 0) throw new Error('Polling options must be positive');
    const initialState = {
        startTime: Date.now(),
        attempts: 0
    };
    const checkTimeout = (state)=>{
        if (options.signal?.aborted) throw new Error('Polling aborted');
        if (Date.now() - state.startTime >= options.maxDuration) throw new (0, $1f028cc32ce8a67c$export$c7a4ee803115cfef)(options.maxDuration);
    };
    async function _poll(state) {
        checkTimeout(state);
        const result = await $ee5ab9a47b321e93$var$withAbort(fn(), options.signal);
        if (!shouldContinue(result)) return result;
        await new Promise((resolve)=>setTimeout(resolve, options.interval));
        return _poll({
            ...state,
            attempts: state.attempts + 1
        });
    }
    if (options.initialDelay > 0) await new Promise((resolve)=>setTimeout(resolve, options.initialDelay));
    return _poll(initialState);
}
function $ee5ab9a47b321e93$var$withAbort(promise, signal) {
    return new Promise((resolve, reject)=>{
        if (signal.aborted) {
            reject(new Error('The operation was aborted'));
            return;
        }
        const abortHandler = ()=>reject(new Error('The operation was aborted'));
        const unbind = (0, $fFa3V.bind)(signal, {
            type: 'abort',
            listener: abortHandler,
            options: {
                once: true
            }
        });
        promise.finally(()=>unbind()).then(resolve, reject).catch(reject);
    });
}


// 5xx HTTP errors that should be retried
class $20fd9f36ee84138f$var$RetryableHttpError extends (0, $jjbGD.FailedFetchError) {
    constructor(message, status){
        super({
            error: new Error(message),
            path: '',
            method: 'GET'
        });
        this.status = void 0;
        this.name = 'RetryableHttpError';
        this.status = status;
    }
}
// Network errors that should be retried
class $20fd9f36ee84138f$var$RetryableNetworkError extends (0, $jjbGD.FailedFetchError) {
    constructor(message){
        super({
            error: new Error(message),
            path: '',
            method: 'GET'
        });
        this.name = 'RetryableNetworkError';
    }
}
// 3 minutes (36 intervals of 5 seconds)
const $20fd9f36ee84138f$var$PROVISIONING_RETRY_INTERVALS = Array(36).fill(5000);
const $20fd9f36ee84138f$var$XFLOW_SERVICE_URL = '/gateway/api/xflow/provision/cloud';
const $20fd9f36ee84138f$var$STOP_PERCENTAGE = 0.9;
const $20fd9f36ee84138f$var$PROGRESS_INCREMENT = 0.02;
const $20fd9f36ee84138f$export$e02dc5b7e3ed1e08 = async ({ cloudId: cloudId, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const response = await fetch(`${$20fd9f36ee84138f$var$XFLOW_SERVICE_URL}/${encodeURIComponent(cloudId)}/product/teamwork-collection/job/core/plan`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        })
    });
    if (!response.ok) throw new Error(`Non-OK response when fetching plan for TWC XFlow provisioning: HTTP ${response.status}: ${response.statusText}`);
    return response.json();
};
const $20fd9f36ee84138f$var$startProvisioning = async ({ cloudId: cloudId, signal: signal, locale: locale, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    try {
        const response = await fetch(`${$20fd9f36ee84138f$var$XFLOW_SERVICE_URL}/${encodeURIComponent(cloudId)}/product/teamwork-collection/job/core/start`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sourceComponent: sourceComponent,
                sourceContext: sourceContext,
                locale: locale
            }),
            signal: signal
        });
        if (!response.ok) throw new Error(`Non-OK response when starting TWC XFlow provisioning: HTTP ${response.status}: ${response.statusText}`);
        return response.json();
    } catch (error) {
        (0, $kDHbX.captureException)('Failed to start TWC XFlow provisioning', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
        throw error;
    }
};
const $20fd9f36ee84138f$var$checkStatus = async ({ cloudId: cloudId })=>{
    const isRetryEnabled = (0, $dh538.fg)('twc_provisioning_retry_gate');
    try {
        const response = await fetch(`${$20fd9f36ee84138f$var$XFLOW_SERVICE_URL}/${encodeURIComponent(cloudId)}/product/teamwork-collection/job/core/status`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (isRetryEnabled && !response.ok) {
            if (response.status >= 500) throw new $20fd9f36ee84138f$var$RetryableHttpError(`HTTP ${response.status}: ${response.statusText}`, response.status);
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
    } catch (error) {
        (0, $kDHbX.captureException)('Failed to check the status of TWC XFlow provisioning', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
        if (isRetryEnabled && error instanceof TypeError && error.message.includes('fetch')) throw new $20fd9f36ee84138f$var$RetryableNetworkError(`Network error: ${error.message}`);
        throw error;
    }
};
const $20fd9f36ee84138f$var$trackProvisionJob = async ({ cloudId: cloudId, tasks: tasks, callback: callback, pollingOptions: pollingOptions, initialStatus: initialStatus })=>{
    try {
        let statusResponse = initialStatus;
        let completedTasks = new Set();
        let lastSeenTask = initialStatus.step;
        let progress = 0;
        await (0, $ee5ab9a47b321e93$export$e0c10349b2c5e1d4)(async ()=>{
            if ((0, $dh538.fg)('twc_provisioning_retry_gate')) statusResponse = await (0, $jjbGD.retryOnException)(()=>$20fd9f36ee84138f$var$checkStatus({
                    cloudId: cloudId
                }), {
                intervalsMS: $20fd9f36ee84138f$var$PROVISIONING_RETRY_INTERVALS,
                retryOn: (error)=>error instanceof $20fd9f36ee84138f$var$RetryableHttpError || error instanceof $20fd9f36ee84138f$var$RetryableNetworkError
            });
            else statusResponse = await $20fd9f36ee84138f$var$checkStatus({
                cloudId: cloudId
            });
            let taskCompleted = false;
            if (statusResponse.step !== lastSeenTask) {
                lastSeenTask = statusResponse.step;
                completedTasks.add(lastSeenTask);
                taskCompleted = true;
            }
            // Handle Provision status: https://hello.atlassian.net/wiki/spaces/DISC/pages/3922151447/Xflow+Provisioning+API+-+Concept#Available-Status
            switch(statusResponse.status){
                case 'PROVISIONING_IN_PROGRESS':
                    const currentTaskPercentage = completedTasks.size / tasks.length;
                    const nextTaskPercentage = (completedTasks.size + 1) / tasks.length;
                    if (taskCompleted) progress = currentTaskPercentage;
                    else if (progress < $20fd9f36ee84138f$var$STOP_PERCENTAGE && progress < nextTaskPercentage) progress += $20fd9f36ee84138f$var$PROGRESS_INCREMENT;
                    callback(progress, statusResponse);
                    return true;
                case 'PROVISIONING_COMPLETED':
                    // We are done clear completed tasks
                    completedTasks.clear();
                    callback(1, statusResponse);
                    return false;
                case 'PROVISIONING_ABORTED':
                    throw new Error('Provisioning aborted');
                case 'PROVISIONING_FAILED':
                    throw new Error('Provisioning failed');
                default:
                    throw new Error(`Unknown status found: ${statusResponse.status} `);
            }
        }, // Continue until provisioning is on end state
        (response)=>response, pollingOptions);
        return {
            ...statusResponse,
            progress: 1
        };
    } catch (error) {
        (0, $kDHbX.captureException)('Error when tracking provisioning status for job', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
        throw error;
    }
};
const $20fd9f36ee84138f$export$1d6d652748d7c87d = async ({ cloudId: cloudId, callback: callback, pollingOptions: pollingOptions, initialStatus: initialStatus, locale: locale, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    try {
        let startResponse;
        if (!initialStatus) startResponse = await $20fd9f36ee84138f$var$startProvisioning({
            cloudId: cloudId,
            signal: pollingOptions.signal,
            locale: locale,
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        });
        const statusResponse = await $20fd9f36ee84138f$var$checkStatus({
            cloudId: cloudId
        });
        switch(statusResponse.status){
            default:
            case 'PROVISIONING_IN_PROGRESS':
                return $20fd9f36ee84138f$var$trackProvisionJob({
                    cloudId: cloudId,
                    tasks: startResponse?.tasks ?? [
                        {
                            name: 'dummy-task'
                        }
                    ],
                    callback: callback,
                    pollingOptions: pollingOptions,
                    initialStatus: statusResponse
                });
            case 'PROVISIONING_ABORTED':
                throw new Error('Provisioning aborted');
            case 'PROVISIONING_FAILED':
                throw new Error('Provisioning failed');
            case 'PROVISIONING_COMPLETED':
                return {
                    ...statusResponse,
                    progress: 1
                };
        }
    } catch (error) {
        (0, $kDHbX.captureException)('Error when starting and tracking provisioning', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
        throw error;
    }
};


const $1ba1c983bdf2e115$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $1ba1c983bdf2e115$var$getActivationCapabilityFromReasons = (reasons)=>{
    if (reasons?.some((reason)=>reason === 'user-cannot-add-product')) return 'requires-approval';
    return 'can-activate';
};
const $1ba1c983bdf2e115$var$fetchSiteTraits = async (cloudId)=>{
    const response = await fetch(`/gateway/api/tap-delivery/api/v3/personalization/site/${encodeURIComponent(cloudId)}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    if (!response.ok) throw new Error(`Non-OK response when fetching site traits: HTTP ${response.status}: ${response.statusText}`);
    return response.json();
};
const $1ba1c983bdf2e115$var$getPriceIncreaseTraitValue = async (cloudId)=>{
    const response = await $1ba1c983bdf2e115$var$fetchSiteTraits(cloudId);
    const hasTrait = response.attributes.find((trait)=>trait.name === 'site-twc-price-percentage-increase');
    if (!hasTrait) return {
        segmentation: 'increase'
    };
    const priceChangeValue = hasTrait.value;
    if (!Number.isInteger(priceChangeValue)) return {
        segmentation: 'increase'
    };
    if (priceChangeValue < 0) return {
        segmentation: 'decrease',
        value: priceChangeValue
    };
    else if (priceChangeValue === 0) return {
        segmentation: 'same',
        value: priceChangeValue
    };
    return {
        segmentation: 'increase',
        value: priceChangeValue
    };
};
const $1ba1c983bdf2e115$export$bce67339319127f5 = async (cloudId, sourceComponent, sourceContext)=>{
    const [userProducts, planResponse, pricing] = await Promise.all([
        (0, $e9b1f63481f8c476$export$870466e371fb4e1e)(cloudId),
        (0, $20fd9f36ee84138f$export$e02dc5b7e3ed1e08)({
            cloudId: cloudId,
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        }),
        $1ba1c983bdf2e115$var$getPriceIncreaseTraitValue(cloudId)
    ]);
    const allowed = planResponse.allowed;
    const inProgress = planResponse?.reasons?.some((reason)=>reason === 'Job is already running') ?? false;
    const provisioningCompleted = planResponse?.reasons?.some((reason)=>reason === 'product-already-active') ?? false;
    const status = provisioningCompleted ? 'PROVISIONING_COMPLETED' : planResponse?.context?.status; // future behavior: xflow will only return status if the job is running
    const hasPaymentDetails = planResponse?.tasks?.[0]?.context?.hasPaymentDetails;
    if ($1ba1c983bdf2e115$var$isNullOrUndefined(hasPaymentDetails)) throw new Error('Missing hasPaymentDetails from plan endpoint');
    const edition = planResponse?.tasks?.[0]?.context?.edition?.id;
    if ($1ba1c983bdf2e115$var$isNullOrUndefined(edition)) throw new Error('Missing edition from plan endpoint');
    const activationCapability = $1ba1c983bdf2e115$var$getActivationCapabilityFromReasons(planResponse?.reasons);
    return {
        modalData: {
            edition: edition,
            hasPaymentDetails: hasPaymentDetails,
            userProducts: userProducts,
            status: status,
            priceSegmentation: pricing.segmentation,
            priceValue: pricing.value,
            activationCapability: activationCapability
        },
        allowed: allowed,
        inProgress: inProgress
    };
};
















const $eaffa4b1a723cea5$var$STORAGE_KEY = 'twc-xflow-modal-requested-trial';
const $eaffa4b1a723cea5$export$c9afdcd809810038 = (cloudId, link)=>{
    try {
        const storedData = localStorage.getItem($eaffa4b1a723cea5$var$STORAGE_KEY);
        const existingTrials = storedData ? JSON.parse(storedData) : {};
        existingTrials[cloudId] = {
            cloudId: cloudId,
            link: link
        };
        localStorage.setItem($eaffa4b1a723cea5$var$STORAGE_KEY, JSON.stringify(existingTrials));
    } catch (error) {
        (0, $kDHbX.captureException)('Failed to save requested trial to local storage', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
    }
};
const $eaffa4b1a723cea5$export$45e741e8e28c95c2 = (cloudId)=>{
    try {
        const storedData = localStorage.getItem($eaffa4b1a723cea5$var$STORAGE_KEY);
        if (!storedData) return [
            false,
            null
        ];
        const allTrials = JSON.parse(storedData);
        const trialData = allTrials[cloudId];
        if (trialData) return [
            true,
            trialData
        ];
        return [
            false,
            null
        ];
    } catch (error) {
        (0, $kDHbX.captureException)('Failed to check requested trial in local storage', error, {
            cloudId: cloudId,
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
        return [
            false,
            null
        ];
    }
};
const $eaffa4b1a723cea5$export$f43dce91eb7d6af2 = ()=>{
    try {
        localStorage.removeItem($eaffa4b1a723cea5$var$STORAGE_KEY);
    } catch (error) {
        // Silently fail if localStorage is not available
        (0, $kDHbX.captureException)('Failed to clear requested trial from local storage', error, {
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
    }
};


const $9a2d95c7a8f18111$var$styles = {
    content: "_1bsb1osq _ca0q1ejb _19bv1ejb _u5f31ejb _oqicoahv _pnmboahv _1rmjoahv",
    cta: "_19pkv47k _16jlkb7n _1e0c1txw _2lx21bp4 _1bahesu3 _4cvrh9n0",
    modalContent: "_2rko1mok _1e0c1txw _2lx2vrvc _bfhkhp5a",
    leftColumn: "_1e0c1txw _2lx21bp4 _16jlkb7n _ca0q1jfw _19bv1jfw _u5f3xy5q _n3td1jfw",
    rightColumn: "_1e0cglyw _1vdkidpf _dm251txw _oqicxy5q _pnmbxy5q _1rmjxy5q _cjbtxy5q",
    heading: "_19pk1ejb",
    subheading: "_11c8wadc _19pk1b66",
    newApps: "_19pk1ejb",
    newApp: "_1e0c1txw _2lx2vrvc _4cvr1h6o _19pku2gc",
    newAppFirst: "_19pkidpf",
    newAppText: "_1reo15vq _18m915vq _18u0utpp _1e0c1txw _2lx21bp4 _1bto1l2s _o5721q9c",
    existingAppsHeader: "_11c8wadc _19pk1ejb",
    existingApps: "_zulppxbi _1e0c1txw _2lx2vrvc",
    existingAppText: "_18u012x7",
    legalText: "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1tke8vuz _y3gn1h6o",
    secondLine: "_19pku2gc"
};
const $9a2d95c7a8f18111$export$e2b0760399e6dece = ({ setApprovalUrl: setApprovalUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isDarkMode = (0, $0fd45bf3f75c7971$export$c720381daa58fcbb)();
    const { cloudId: cloudId, sourceComponent: sourceComponent, sourceContext: sourceContext, setCurrentScreen: setCurrentScreen, setModalState: setModalState } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        const loadModalData = async ()=>{
            try {
                const data = await (0, $1ba1c983bdf2e115$export$bce67339319127f5)(cloudId, sourceComponent, sourceContext);
                if (data.modalData.activationCapability !== 'can-activate') {
                    const [hasRequested, requestedTrialData] = (0, $eaffa4b1a723cea5$export$45e741e8e28c95c2)(cloudId);
                    if (hasRequested && requestedTrialData) {
                        setModalState(data.modalData);
                        setApprovalUrl(requestedTrialData.link);
                        setCurrentScreen('requested-trial-screen');
                        return;
                    }
                    setModalState(data.modalData);
                    setCurrentScreen('confirmation');
                    return;
                }
                if (!data.allowed && !data.inProgress && !data.modalData?.status) {
                    setCurrentScreen('error');
                    return;
                }
                setModalState(data.modalData);
                if (data.inProgress || data.modalData?.status) setCurrentScreen('provisioning');
                else setCurrentScreen('confirmation');
            } catch (error) {
                setCurrentScreen('error');
                (0, $kDHbX.captureException)('Failed to fetch TWC XFlow modal data', error, {
                    cloudId: cloudId,
                    packageName: '@atlassian/twc-xflow-modal',
                    teamName: 'starburst'
                });
            }
        };
        loadModalData();
    }, [
        cloudId,
        setCurrentScreen,
        setModalState,
        setApprovalUrl,
        sourceComponent,
        sourceContext
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalLoadingScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    (0, $42omo.useEffect)(()=>{
        const preloadImages = isDarkMode ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($ba00c4af743cca2a$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($04baef9fdbf74f8c$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b5d80395174c93b0$exports)))
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($a1ea08d599f9bd15$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($2ae1aab4f6bcae8b$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($d1800ff4524f9f89$exports)))
        ];
        preloadImages.map((src)=>{
            new Image().src = src;
        });
    }, [
        isDarkMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout), {
        testId: "loading-screen",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
            xcss: $9a2d95c7a8f18111$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                    xcss: $9a2d95c7a8f18111$var$styles.modalContent,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                            xcss: $9a2d95c7a8f18111$var$styles.leftColumn,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                        width: "134px",
                                        height: "32px"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                                    xcss: $9a2d95c7a8f18111$var$styles.heading,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            width: "100%",
                                            height: "20px"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                            xcss: $9a2d95c7a8f18111$var$styles.secondLine,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                                width: "100%",
                                                height: "20px"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                    xcss: $9a2d95c7a8f18111$var$styles.subheading,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                        width: "200px",
                                        height: "16px"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                    xcss: $9a2d95c7a8f18111$var$styles.newApps,
                                    children: [
                                        1,
                                        2
                                    ].map((newApp, index)=>{
                                        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                                            xcss: (0, $1Whri.cx)($9a2d95c7a8f18111$var$styles.newApp, index === 0 && $9a2d95c7a8f18111$var$styles.newAppFirst),
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                                    width: "32px",
                                                    height: "32px"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                                                    xcss: $9a2d95c7a8f18111$var$styles.newAppText,
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                                            width: "60px",
                                                            height: "16px"
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                                            xcss: $9a2d95c7a8f18111$var$styles.secondLine,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                                                width: "200px",
                                                                height: "12px"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, newApp);
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                    xcss: $9a2d95c7a8f18111$var$styles.existingAppsHeader,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                        width: "200px",
                                        height: "16px"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                    xcss: $9a2d95c7a8f18111$var$styles.existingApps,
                                    children: [
                                        1,
                                        2
                                    ].map((existingApp)=>{
                                        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                                            xcss: $9a2d95c7a8f18111$var$styles.newApp,
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                                    width: "32px",
                                                    height: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                                    xcss: $9a2d95c7a8f18111$var$styles.existingAppText,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                                        width: "60px",
                                                        height: "20px"
                                                    })
                                                })
                                            ]
                                        }, existingApp);
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                                    xcss: $9a2d95c7a8f18111$var$styles.cta,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                        width: "132px",
                                        height: "32px"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                            xcss: $9a2d95c7a8f18111$var$styles.rightColumn,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                width: "345px",
                                height: "400px",
                                color: "var(--ds-surface-sunken, #F8F8F8)"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                    xcss: $9a2d95c7a8f18111$var$styles.legalText,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "100%",
                        height: "20px"
                    })
                })
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");






























var $82gXq = parcelRequire("82gXq");




var $b947dba9a5e043da$exports = {};
$b947dba9a5e043da$exports = new URL("teamwork_collection_header.dark.0d6ead39.png", import.meta.url).toString();


var $81f734c2219a7b71$exports = {};
$81f734c2219a7b71$exports = new URL("teamwork_collection_header.light.46f39a8e.png", import.meta.url).toString();






const $8cf60341312d4e8a$export$5dfea0a567afe244 = (0, $cgtv4.defineMessages)({
    confirmationTitle: {
        id: "twc.normalize-seat-modal.confirmation.title",
        defaultMessage: "Give your teammates access to all Teamwork Collection apps"
    },
    confirmationDescription: {
        id: "twc.normalize-seat-modal.confirmation.description",
        defaultMessage: "You can update permissions anytime in {link}."
    },
    toggleText: {
        id: "twc.normalize-seat-modal.toggle.text",
        defaultMessage: "Grant access"
    },
    confirmButton: {
        id: "twc.normalize-seat-modal.confirmation.try-now",
        defaultMessage: "Confirm"
    },
    toggleWarning: {
        id: "twc.normalize-seat-modal.toggle.warning",
        defaultMessage: "Turning this off means your team won't get access."
    },
    administrationLink: {
        id: "twc.normalize-seat-modal.confirmation.administration-link",
        defaultMessage: "Atlassian Administration"
    },
    appTilesAlt: {
        id: "twc.normalize-seat-modal.app-tiles.alt",
        defaultMessage: "App tiles completion illustration"
    },
    teamworkCollectionAlt: {
        id: "twc.xflow.modal.teamwork.collection.alt",
        defaultMessage: "Teamwork collection illustration"
    }
});


const $70c7a240a59f4aec$var$AdministrationLink = ({ orgId: orgId })=>{
    const href = orgId ? `https://admin.atlassian.com/o/${orgId}/users` : '/admin';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $8cf60341312d4e8a$export$5dfea0a567afe244).administrationLink
        })
    });
};
const $70c7a240a59f4aec$var$styles = {
    content: "_zulp1ejb _1e0c1txw _4t3i1osq _ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv _2lx21bp4 _4cvr1y6m _1bah1yb4 _16jlkb7n _glte1ssb",
    product: "_zulpxy5q _1e0c1txw _2lx21bp4 _1bsb1osq",
    message: "_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1y6m",
    toggleContainer: "_zulpu2gc _2rkolb4i _1e0c11p5 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _yv0e5bpd _4cvr1h6o _uiztglyw",
    toggleContainerEnabled: "_bfhkm890",
    toggleContainerDisabled: "_bfhkhfxm",
    label: "_80omtlke",
    actions: "_zulp1b66 _1e0c1txw _1wpzesu3"
};
const $70c7a240a59f4aec$export$7c6e2c02157bb7d2 = ({ onConfirm: onConfirm, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const { orgId: orgId, redirectUrl: redirectUrl, isNormalizeSeatsEnabled: isEnabled, setIsNormalizeSeatsEnabled: setIsNormalizeSeatsEnabled } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    const handleToggleChange = ()=>{
        const newValue = !isEnabled;
        setIsNormalizeSeatsEnabled(newValue);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalNormalizeSeatToggle',
            source: 'twcXflowModalNormalizeSeatScreen',
            attributes: {
                isEnabled: newValue
            }
        }).fire('growth');
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $70c7a240a59f4aec$var$styles.content,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $70c7a240a59f4aec$var$styles.product,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($b947dba9a5e043da$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($81f734c2219a7b71$exports))),
                        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b947dba9a5e043da$exports))),
                        alt: formatMessage((0, $8cf60341312d4e8a$export$5dfea0a567afe244).teamworkCollectionAlt),
                        testId: "teamwork-collection-header",
                        width: "168",
                        height: "auto"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $70c7a240a59f4aec$var$styles.message,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "large",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $8cf60341312d4e8a$export$5dfea0a567afe244).confirmationTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "medium",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $8cf60341312d4e8a$export$5dfea0a567afe244).confirmationDescription,
                                    values: {
                                        link: /*#__PURE__*/ (0, $l998X.jsx)($70c7a240a59f4aec$var$AdministrationLink, {
                                            orgId: orgId
                                        })
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($70c7a240a59f4aec$var$styles.toggleContainer, isEnabled ? $70c7a240a59f4aec$var$styles.toggleContainerEnabled : $70c7a240a59f4aec$var$styles.toggleContainerDisabled),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                                id: "normalize-seat-toggle",
                                isChecked: isEnabled,
                                onChange: handleToggleChange
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("label", {
                                htmlFor: "normalize-seat-toggle",
                                className: (0, $gMc0m.default)([
                                    $70c7a240a59f4aec$var$styles.label
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $8cf60341312d4e8a$export$5dfea0a567afe244).toggleText
                                    })
                                })
                            }),
                            !isEnabled && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {}),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $8cf60341312d4e8a$export$5dfea0a567afe244).toggleWarning
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $70c7a240a59f4aec$var$styles.actions,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                    appearance: "primary",
                    href: redirectUrl,
                    onClick: (e)=>{
                        e.preventDefault();
                        onConfirm();
                    },
                    testId: testId ? `${testId}-confirm` : undefined,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $8cf60341312d4e8a$export$5dfea0a567afe244).confirmButton
                    })
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


parcelRequire("42omo");













var $12f3f57642a3197b$exports = {};
$12f3f57642a3197b$exports = new URL("app-tiles.dark.8e97838c.png", import.meta.url).toString();


var $4c3e5ac179d0b55a$exports = {};
$4c3e5ac179d0b55a$exports = new URL("app-tiles.light.c0171e78.png", import.meta.url).toString();


var $5908477ef596db84$exports = {};
$5908477ef596db84$exports = new URL("normalizeSeatBackground.dark.3ce9cef1.png", import.meta.url).toString();


var $ece13c2fa30961b5$exports = {};
$ece13c2fa30961b5$exports = new URL("normalizeSeatBackground.light.c079ea47.png", import.meta.url).toString();



const $18c9599dfcf900cc$var$styles = {
    container: "_1e0cglyw _165t1osq _9szs1dfr _s7vk1ssb _qhetmgnk _13wnh2mm _o0ba12b0 _zsqy12b0 _dm251txw _msup1h6o _1jsv1h6o _oqicxy5q _1rmjxy5q _cjbtxy5q _pnmbxy5q _glte1ssb"
};
const $18c9599dfcf900cc$export$bd5f74f661bfae4e = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isDarkMode = colorMode === 'dark';
    const backgroundImage = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($5908477ef596db84$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ece13c2fa30961b5$exports)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $18c9599dfcf900cc$var$styles.container,
        style: {
            backgroundImage: `url(${backgroundImage})`
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
            src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($12f3f57642a3197b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($4c3e5ac179d0b55a$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($12f3f57642a3197b$exports))),
            alt: formatMessage((0, $8cf60341312d4e8a$export$5dfea0a567afe244).appTilesAlt),
            testId: "app-tiles"
        })
    });
};


const $15b6b1b5c59c03a0$var$styles = {
    modal: "_1e0c1txw _4t3i1osq"
};
const $15b6b1b5c59c03a0$export$db80c0ce62bed0a3 = ({ onConfirm: onConfirm, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalNormalizeSeatScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout), {
        testId: "normalize-seat-screen",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $15b6b1b5c59c03a0$var$styles.modal,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $70c7a240a59f4aec$export$7c6e2c02157bb7d2), {
                    onConfirm: onConfirm,
                    testId: testId
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $18c9599dfcf900cc$export$bd5f74f661bfae4e), {})
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 












var $eyWa4 = parcelRequire("eyWa4");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");












var $6UBEn = parcelRequire("6UBEn");




const $692bbee3a2a580d6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    progress: {
        id: "twc.xflow.modal.progress",
        defaultMessage: "Getting your collection ready\u2014this will only take a moment. You will be redirected shortly."
    }
});


const $1901c6eb0ced6b59$var$styles = {
    container: "_zulpu2gc",
    progressContainer: "_2rko12b0 _1bsb1osq"
};
const $1901c6eb0ced6b59$export$a9d143800e254c06 = ({ progress: progress })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const progressBarAppearance = progress === 1 ? 'success' : 'default';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $1901c6eb0ced6b59$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $1901c6eb0ced6b59$var$styles.progressContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6UBEn.default), {
                    value: progress,
                    appearance: progressBarAppearance,
                    ariaLabel: "Provisioning in progress"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                align: "center",
                size: "small",
                color: "color.text.subtlest",
                children: formatMessage((0, $692bbee3a2a580d6$export$defe85febe8b728c).progress)
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


parcelRequire("42omo");


var $jSpMW = parcelRequire("jSpMW");





var $1sDXW = parcelRequire("1sDXW");


var $a48Rq = parcelRequire("a48Rq");

const $36e067422a7d4bad$var$styles = {
    backgroundAnimation: "_1e0cglyw _dm251ule _13wnstnw _1sbqidpf _bjm4idpf _1xkaidpf _1r6vidpf _hyzqidpf _1qbjglyw _glte1qhy"
};

const $36e067422a7d4bad$var$loadLightAnimation = ()=>{
    return (parcelRequire("9KJ3M"));
};

const $36e067422a7d4bad$var$loadDarkAnimation = ()=>{
    return (parcelRequire("eahLs"));
};
const $36e067422a7d4bad$export$474a33165cfcc2de = ()=>{
    const backgroundAnimation = (0, $a48Rq.useThemeAnimation)($36e067422a7d4bad$var$loadLightAnimation, $36e067422a7d4bad$var$loadDarkAnimation);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $36e067422a7d4bad$var$styles.backgroundAnimation,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1sDXW.Skeleton), {
            isLoading: !backgroundAnimation,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSpMW))), {
                animationData: backgroundAnimation,
                loop: false
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













const $199b38cfb15ceb95$var$styles = {
    iconsContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};

const $199b38cfb15ceb95$var$loadLightIconsAnimation = ()=>{
    return (parcelRequire("3oQfv"));
};

const $199b38cfb15ceb95$var$loadDarkIconsAnimation = ()=>{
    return (parcelRequire("3yhHL"));
};
const $199b38cfb15ceb95$export$88bcf43bee441945 = ()=>{
    const iconsAnimation = (0, $a48Rq.useThemeAnimation)($199b38cfb15ceb95$var$loadLightIconsAnimation, $199b38cfb15ceb95$var$loadDarkIconsAnimation);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $199b38cfb15ceb95$var$styles.iconsContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1sDXW.Skeleton), {
            isLoading: !iconsAnimation,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSpMW))), {
                animationData: iconsAnimation,
                loop: true
            })
        })
    });
};






const $0b63c77697f022bc$var$styles = {
    container: "_ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb"
};
const $0b63c77697f022bc$var$DEFAULT_MAX_DURATION = 300000; // 5 minutes
const $0b63c77697f022bc$var$REDUCED_MAX_DURATION = 120000; // 2 minutes
const $0b63c77697f022bc$var$getPollingOptions = ()=>({
        initialDelay: 0,
        interval: 1000,
        maxDuration: (0, $dh538.fg)('twc-xflow-timeout-screen') ? $0b63c77697f022bc$var$REDUCED_MAX_DURATION : $0b63c77697f022bc$var$DEFAULT_MAX_DURATION
    });
const $0b63c77697f022bc$export$ebb96ceb0e1178aa = ({ onProvisioningComplete: onProvisioningComplete })=>{
    const [progress, setProgress] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, locale: locale, sourceComponent: sourceComponent, sourceContext: sourceContext, modalState: { status: status }, setCurrentScreen: setCurrentScreen } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        const controller = new AbortController();
        const startProvisioningAndTrackStatus = async ()=>{
            try {
                createAnalyticsEvent({
                    eventType: 'track',
                    action: status ? 'provisioningResumed' : 'provisioningStarted',
                    actionSubject: 'progressBar',
                    actionSubjectId: 'twcXflowModal',
                    attributes: {
                        sourceComponent: sourceComponent,
                        sourceContext: sourceContext
                    }
                }).fire('growth');
                const response = await (0, $20fd9f36ee84138f$export$1d6d652748d7c87d)({
                    cloudId: cloudId,
                    callback: (progress, statusResponse)=>{
                        if (!controller.signal.aborted) setProgress(progress);
                        if (statusResponse.status === 'PROVISIONING_COMPLETED') createAnalyticsEvent({
                            eventType: 'track',
                            action: 'provisioningCompleted',
                            actionSubject: 'progressBar',
                            actionSubjectId: 'twcXflowModal',
                            attributes: {
                                sourceComponent: sourceComponent,
                                sourceContext: sourceContext
                            }
                        }).fire('growth');
                    },
                    pollingOptions: {
                        ...$0b63c77697f022bc$var$getPollingOptions(),
                        signal: controller.signal
                    },
                    initialStatus: status,
                    locale: locale,
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext
                });
                if (!controller.signal.aborted) {
                    setProgress(response.progress);
                    if (response.status === 'PROVISIONING_COMPLETED') setTimeout(()=>{
                        if (!controller.signal.aborted) {
                            const redirectUrl = response.context?.onboardingUrl;
                            if (!redirectUrl) (0, $kDHbX.captureException)('redirect url not provided', new Error('Redirect url not provided'), {
                                packageName: '@atlassian/twc-xflow-modal',
                                teamName: 'starburst'
                            });
                            onProvisioningComplete(redirectUrl);
                        }
                    }, 1000);
                }
            } catch (error) {
                if (!controller.signal.aborted) {
                    if ((0, $1f028cc32ce8a67c$export$c7a4ee803115cfef).is(error) && (0, $dh538.fg)('twc-xflow-timeout-screen')) {
                        createAnalyticsEvent({
                            eventType: 'track',
                            action: 'provisioningTimedOut',
                            actionSubject: 'progressBar',
                            actionSubjectId: 'twcXflowModal',
                            attributes: {
                                sourceComponent: sourceComponent,
                                sourceContext: sourceContext,
                                maxDuration: error.maxDuration
                            }
                        }).fire('growth');
                        setCurrentScreen('timeout');
                    } else {
                        (0, $kDHbX.captureException)('Provisioning failed - showing error screen', new Error(error instanceof Error ? error.name : 'Unknown error'), {
                            packageName: '@atlassian/twc-xflow-modal',
                            teamName: 'starburst'
                        });
                        setCurrentScreen('error');
                    }
                }
            }
        };
        startProvisioningAndTrackStatus();
        return ()=>{
            controller.abort();
        };
    }, [
        cloudId,
        setCurrentScreen,
        onProvisioningComplete,
        createAnalyticsEvent,
        status,
        locale,
        sourceComponent,
        sourceContext
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalProvisioningScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $jO0hz.ScreenLayout), {
        testId: "provisioning-screen",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $36e067422a7d4bad$export$474a33165cfcc2de), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout).Content, {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    xcss: $0b63c77697f022bc$var$styles.container,
                    alignBlock: "center",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $199b38cfb15ceb95$export$88bcf43bee441945), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1901c6eb0ced6b59$export$a9d143800e254c06), {
                            progress: progress
                        })
                    ]
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 























var $2MuFw = parcelRequire("2MuFw");













var $4noo5 = parcelRequire("4noo5");















var $hTKp4 = parcelRequire("hTKp4");

const $71db3d4902c83753$export$d59a452d6b3a29e2 = (text, options)=>{
    const { onCopy: onCopy, resetTimeout: resetTimeout = 3000 } = options || {};
    const [copied, setCopied] = (0, $42omo.useState)(false);
    const copy = (0, $42omo.useCallback)(async ()=>{
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            onCopy?.();
            // Reset the success message after the specified timeout
            setTimeout(()=>{
                setCopied(false);
            }, resetTimeout);
        } catch (error) {
            // Fallback for browsers that don't support clipboard API
            const doc = (0, $hTKp4.getDocument)();
            if (!doc) return;
            const textArea = doc.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            doc.body.appendChild(textArea);
            textArea.select();
            doc.execCommand('copy');
            doc.body.removeChild(textArea);
            setCopied(true);
            onCopy?.();
            setTimeout(()=>{
                setCopied(false);
            }, resetTimeout);
        }
    }, [
        text,
        onCopy,
        resetTimeout
    ]);
    return {
        copy: copy,
        copied: copied
    };
};






const $ef7ff47ae7cba257$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    teamworkCollectionAlt: {
        id: "twc.xflow.modal.requested.trial.screen.teamwork.collection.alt",
        defaultMessage: "Teamwork Collection"
    },
    heading: {
        id: "twc.xflow.modal.requested.trial.screen.heading",
        defaultMessage: "Your request is pending"
    },
    explanation: {
        id: "twc.xflow.modal.requested.trial.screen.explanation",
        defaultMessage: "The admin for your workspace needs to approve the request before you can try Teamwork Collection."
    },
    shareLinkPrompt: {
        id: "twc.xflow.modal.requested.trial.screen.share.link.prompt",
        defaultMessage: "For faster approval, share the link below with your admin"
    },
    copyLinkButton: {
        id: "twc.xflow.modal.requested.trial.screen.copy.link.button",
        defaultMessage: "Copy link"
    },
    closeButton: {
        id: "twc.xflow.modal.requested.trial.screen.close.button",
        defaultMessage: "Close"
    },
    linkCopied: {
        id: "twc.xflow.modal.requested.trial.screen.link.copied",
        defaultMessage: "Link copied!"
    },
    visualAlt: {
        id: "twc.xflow.modal.teamwork.collection.requested.trial.screen.visual.alt",
        defaultMessage: "A graphic that displays Jira, Confluence, Confluence, and Loom integrations"
    },
    closeModal: {
        id: "twc.xflow.modal.teamwork.collection.requested.trial.screen.close",
        defaultMessage: "Close modal"
    },
    requestLinkInputLabel: {
        id: "twc.xflow.modal.requested.trial.screen.request.link.input.label",
        defaultMessage: "Trial request link"
    }
});


const $c383c647cfd75ecd$var$styles = {
    content: "_1e0c1txw _4t3i1osq _2lx21bp4 _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb _oqicoahv _pnmboahv _1rmjoahv _cjbtoahv",
    closeButton: "_kqswstnw _154i1jfw _1xi21jfw _1sbqpxbi _1r6vpxbi",
    modalContent: "_2rko1mok _1e0c1txw _16jlkb7n _2lx2vrvc _bfhkhp5a",
    header: "_1e0c1txw _2lx21bp4",
    heading: "_19pk1ejb",
    shareLinkSection: "_zulpu2gc _1e0c1txw _2lx21bp4 _19pk1ejb",
    linkInputContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    textfieldWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    copyButton: "_1o9zidpf",
    actions: "_1e0c1txw _1bahesu3 _19pk1wug _ca0qxy5q",
    successMessage: "_19pk1b66",
    leftColumn: "_1e0c1txw _2lx21bp4 _16jlkb7n _ca0q1jfw _19bv1jfw _u5f3xy5q _n3td1jfw",
    rightColumn: "_1e0cglyw _1vdkidpf _dm251txw _oqicxy5q _pnmbxy5q _1rmjxy5q _cjbtxy5q",
    subheading: "_11c8wadc _19pk1b66"
};
const $c383c647cfd75ecd$var$textfieldStyles = null;
const $c383c647cfd75ecd$export$164db6a68b9a95ea = ({ onClose: onClose, approvalUrl: approvalUrl })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isDarkMode = (0, $0fd45bf3f75c7971$export$c720381daa58fcbb)();
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalRequestedTrialScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    const { copy: handleCopyLink, copied: linkCopied } = (0, $71db3d4902c83753$export$d59a452d6b3a29e2)(approvalUrl ?? '', {
        onCopy: ()=>{
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'twcXflowModalRequestedTrialScreenCopyLink',
                attributes: {
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext
                }
            }).fire('growth');
        }
    });
    const handleClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalRequestedTrialScreenClose',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout), {
        testId: "requested-trial-screen",
        ModalBackgroundDark: (0, (/*@__PURE__*/$parcel$interopDefault($04baef9fdbf74f8c$exports))),
        ModalBackgroundLight: (0, (/*@__PURE__*/$parcel$interopDefault($2ae1aab4f6bcae8b$exports))),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $c383c647cfd75ecd$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $c383c647cfd75ecd$var$styles.closeButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                        onClick: onClose,
                        label: formatMessage((0, $ef7ff47ae7cba257$export$defe85febe8b728c).closeModal)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $c383c647cfd75ecd$var$styles.modalContent,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            xcss: $c383c647cfd75ecd$var$styles.leftColumn,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    xcss: $c383c647cfd75ecd$var$styles.header,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                            src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($ba00c4af743cca2a$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a1ea08d599f9bd15$exports))),
                                            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ba00c4af743cca2a$exports))),
                                            alt: formatMessage((0, $ef7ff47ae7cba257$export$defe85febe8b728c).teamworkCollectionAlt),
                                            testId: "teamwork-collection-header",
                                            width: "134",
                                            height: "32"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $c383c647cfd75ecd$var$styles.heading,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                size: "medium",
                                                testId: "requested-trial-modal-heading",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...(0, $ef7ff47ae7cba257$export$defe85febe8b728c).heading
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $c383c647cfd75ecd$var$styles.subheading,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                testId: "requested-trial-modal-subheading",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...(0, $ef7ff47ae7cba257$export$defe85febe8b728c).explanation
                                                })
                                            })
                                        }),
                                        approvalUrl && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                            xcss: $c383c647cfd75ecd$var$styles.shareLinkSection,
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "inherit",
                                                    weight: "bold",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...(0, $ef7ff47ae7cba257$export$defe85febe8b728c).shareLinkPrompt
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                    xcss: $c383c647cfd75ecd$var$styles.linkInputContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: $c383c647cfd75ecd$var$styles.textfieldWrapper,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                                                                value: approvalUrl || '',
                                                                readOnly: true,
                                                                // @ts-ignore - css prop not in Textfield types but works at runtime
                                                                onChange: ()=>{},
                                                                testId: "request-link-input",
                                                                "aria-label": formatMessage((0, $ef7ff47ae7cba257$export$defe85febe8b728c).requestLinkInputLabel),
                                                                id: "request-link-input",
                                                                className: (0, $gMc0m.default)([
                                                                    "_1srl1ou6"
                                                                ])
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: $c383c647cfd75ecd$var$styles.copyButton,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                                appearance: "default",
                                                                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
                                                                onClick: handleCopyLink,
                                                                testId: "copy-link-button",
                                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                    ...(0, $ef7ff47ae7cba257$export$defe85febe8b728c).copyLinkButton
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                linkCopied && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                    xcss: $c383c647cfd75ecd$var$styles.successMessage,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                        size: "small",
                                                        color: "color.text.success",
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                            ...(0, $ef7ff47ae7cba257$export$defe85febe8b728c).linkCopied
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $c383c647cfd75ecd$var$styles.actions,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "primary",
                                        onClick: handleClose,
                                        testId: "close-button",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $ef7ff47ae7cba257$export$defe85febe8b728c).closeButton
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $c383c647cfd75ecd$var$styles.rightColumn,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($b5d80395174c93b0$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d1800ff4524f9f89$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b5d80395174c93b0$exports))),
                                alt: formatMessage((0, $ef7ff47ae7cba257$export$defe85febe8b728c).visualAlt),
                                testId: "teamwork-collection-visual",
                                width: "345",
                                height: "400"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 




































const $318eefd3bdca34dd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    heading: {
        id: "twc.xflow.modal.timeout.heading",
        defaultMessage: "Activation is taking longer than expected"
    },
    description: {
        id: "twc.xflow.modal.timeout.description",
        defaultMessage: "Don't worry - we're still working on it. You'll receive an email when your products are ready to use."
    },
    closeButton: {
        id: "twc.xflow.modal.timeout.close.button",
        defaultMessage: "Close"
    },
    timeoutIconAlt: {
        id: "twc.xflow.modal.timeout.icon.alt",
        defaultMessage: "Timeout icon"
    }
});


const $9a81940be631c59d$var$styles = {
    modalContent: "_2rko1mok _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _19pkoahv _18u0oahv _2hwxoahv _otyroahv _y3gn1h6o",
    iconWrapper: "_otyrpxbi _19pkxy5q _1e0c1txw _4cvr1h6o _1bah1h6o",
    heading: "_otyrpxbi",
    description: "_otyroahv _p12f1kdj"
};
const $9a81940be631c59d$export$a15a7b5fa3fb3a75 = ({ onClose: onClose })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalTimeoutScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    const handleCloseClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalTimeoutScreenClose',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
        onClose();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout), {
        testId: "timeout-screen",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout).Content, {
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.Box), {
                as: "div",
                xcss: $9a81940be631c59d$var$styles.modalContent,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                        xcss: $9a81940be631c59d$var$styles.iconWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($13484c3c3fe72b94$exports))),
                            width: 150,
                            height: 150,
                            testId: "timeout-icon",
                            alt: intl.formatMessage((0, $318eefd3bdca34dd$export$defe85febe8b728c).timeoutIconAlt)
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                        xcss: $9a81940be631c59d$var$styles.heading,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "medium",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $318eefd3bdca34dd$export$defe85febe8b728c).heading
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
                        xcss: $9a81940be631c59d$var$styles.description,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "medium",
                            weight: "regular",
                            color: "color.text.subtlest",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $318eefd3bdca34dd$export$defe85febe8b728c).description
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "primary",
                        onClick: handleCloseClick,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $318eefd3bdca34dd$export$defe85febe8b728c).closeButton
                        })
                    })
                ]
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


























var $lwfLq = parcelRequire("lwfLq");




const $99219997f461901e$var$getMeta = (name)=>{
    if (typeof document === 'undefined') return undefined;
    const element = document.querySelector(`meta[name="${name}"]`);
    return element?.getAttribute('content') ?? undefined;
};
const $99219997f461901e$var$extractFirstName = (fullName)=>{
    if (!fullName?.trim()) return undefined;
    const firstName = fullName.trim().split(' ')[0];
    return firstName || undefined;
};
const $99219997f461901e$export$32d6fa31f0d8a28 = async ()=>{
    let userData;
    try {
        const response = await fetch('/gateway/api/me');
        if (response.ok) userData = await response.json();
    } catch (error) {
        (0, $kDHbX.captureException)('Failed to fetch user name from API', error, {
            packageName: '@atlassian/twc-xflow-modal',
            teamName: 'starburst'
        });
    }
    const firstName = $99219997f461901e$var$extractFirstName(userData?.nickname) || $99219997f461901e$var$extractFirstName(userData?.name) || $99219997f461901e$var$extractFirstName($99219997f461901e$var$getMeta('ajs-remote-user-fullname'));
    return firstName;
};









const $0328bd04c130379e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    greeting: {
        id: "twc.xflow.modal.welcome.greetingName",
        defaultMessage: "Hi {name}!"
    },
    heading: {
        id: "twc.xflow.modal.welcome.heading",
        defaultMessage: "Welcome to Teamwork Collection"
    },
    description: {
        id: "twc.xflow.modal.welcome.description",
        defaultMessage: "You've unlocked a smarter way for your team to connect, collaborate, and get more done."
    }
});


const $dba47e467632c0bf$var$styles = {
    content: "_zulpu2gc _v5641pus _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _ca0qpxbi _tzy4idpf _t9ec1ymg _19bvpxbi _u5f3pxbi _n3tdpxbi _p12f1osq _dbjg1epz",
    contentVisible: "_tzy4kb7n _t9ec1kli",
    description: "_p12f1kdj",
    greeting: "_p12f1kdj _1i4q1hna _ct361wug"
};
const $dba47e467632c0bf$export$8995dcca99dcdafc = ({ onComplete: onComplete })=>{
    const [isContentVisible, setIsContentVisible] = (0, $42omo.useState)(false);
    const [userName, setUserName] = (0, $42omo.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            const name = await (0, $99219997f461901e$export$32d6fa31f0d8a28)();
            setUserName(name);
            createAnalyticsEvent({
                eventType: 'track',
                action: 'completed',
                actionSubject: 'userNameFetch',
                attributes: {
                    hasName: !!name,
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext
                }
            }).fire('growth');
        })();
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcXflowModalWelcomeScreen',
            attributes: {
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    const handleAnimationComplete = (0, $42omo.useCallback)(()=>{
        setIsContentVisible(true); // Auto-complete after 3 seconds
        if (onComplete) setTimeout(onComplete, 3000);
    }, [
        onComplete
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $jO0hz.ScreenLayout), {
        testId: "welcome-screen",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lwfLq.WelcomeAnimation), {
                onComplete: handleAnimationComplete
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jO0hz.ScreenLayout).Content, {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    xcss: (0, $1Whri.cx)($dba47e467632c0bf$var$styles.content, isContentVisible && $dba47e467632c0bf$var$styles.contentVisible),
                    children: [
                        userName && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $dba47e467632c0bf$var$styles.greeting,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "large",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $0328bd04c130379e$export$defe85febe8b728c).greeting,
                                    values: {
                                        name: userName
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "large",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $0328bd04c130379e$export$defe85febe8b728c).heading
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $dba47e467632c0bf$var$styles.description,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "large",
                                weight: "regular",
                                color: "color.text.subtlest",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $0328bd04c130379e$export$defe85febe8b728c).description
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 



const $43f3976b30aa2a96$export$36750747069c3e29 = ({ edition: edition, activationCapability: activationCapability, hasPaymentDetails: hasPaymentDetails })=>{
    const canActivate = activationCapability === 'can-activate';
    const subheader = (0, $42omo.useMemo)(()=>{
        if (!canActivate) return (0, $67f905b5cc424541$export$defe85febe8b728c).requestTrialText;
        return edition === 'premium' ? (0, $67f905b5cc424541$export$defe85febe8b728c).trialTextPremiumPriceIncrease : (0, $67f905b5cc424541$export$defe85febe8b728c).trialTextStandardPriceIncrease;
    }, [
        edition,
        canActivate
    ]);
    const ctaText = (0, $42omo.useMemo)(()=>{
        if (!canActivate) return (0, $67f905b5cc424541$export$defe85febe8b728c).ctaRequestTrialText;
        return hasPaymentDetails ? (0, $67f905b5cc424541$export$defe85febe8b728c).ctaWithPaymentDetailsOnFile : (0, $67f905b5cc424541$export$defe85febe8b728c).ctaNoPaymentDetailsOnFile;
    }, [
        hasPaymentDetails,
        canActivate
    ]);
    return {
        subheader: subheader,
        ctaText: ctaText
    };
};





/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $5d885087b05f69f1$export$65011bf5eae36f6a(locales) {
    return Intl.getCanonicalLocales(locales);
}



var $eKeqs = parcelRequire("eKeqs");


var $lP6Yy = parcelRequire("lP6Yy");

function $16f0348bf660d3ef$export$4659b591c19bdf3d(requestedLocales, availableLocales, defaultLocale, opts) {
    return (0, $eKeqs.ResolveLocale)(availableLocales, (0, $5d885087b05f69f1$export$65011bf5eae36f6a)(requestedLocales), {
        localeMatcher: (opts === null || opts === void 0 ? void 0 : opts.algorithm) || 'best fit'
    }, [], {}, function() {
        return defaultLocale;
    }).locale;
}


const $4075999b3649cf1b$export$b014e1744f82778b = (text)=>{
    let normalized = text;
    normalized = normalized.replace(/&quot;/g, '"');
    normalized = normalized.replace(/&apos;/g, "'");
    normalized = normalized.replace(/&#x27;/g, "'");
    normalized = normalized.replace(/&#x2F;/g, '/');
    normalized = normalized.replace(/&lt;/g, '<');
    normalized = normalized.replace(/&gt;/g, '>');
    normalized = normalized.replace(/&amp;/g, '&');
    normalized = normalized.replace(/'/g, '`');
    return normalized;
};
const $4075999b3649cf1b$export$85dea20acc0c2b17 = [
    'cs',
    'da',
    'de',
    'en',
    'en-GB',
    'en-ZZ',
    'es',
    'fi',
    'fr',
    'hr',
    'hu',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'pl',
    'pt-BR',
    'ru',
    'sl',
    'sr-RS',
    'sr-YR',
    'sv',
    'th',
    'tr',
    'uk',
    'vi',
    'zh',
    'zh-TW'
];
const $4075999b3649cf1b$var$AVAILABLE_LOCALES_SET = new Set($4075999b3649cf1b$export$85dea20acc0c2b17);
const $4075999b3649cf1b$var$isAvailableLocale = (locale)=>{
    return $4075999b3649cf1b$var$AVAILABLE_LOCALES_SET.has(locale);
};





























const $4075999b3649cf1b$var$importLocaleMessages = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("bVIrE"));
        case 'da':
            return (parcelRequire("3Bd6r"));
        case 'de':
            return (parcelRequire("iA2ey"));
        case 'en':
            return (parcelRequire("6TBrL"));
        case 'en-GB':
            return (parcelRequire("depve"));
        case 'en-ZZ':
            return (parcelRequire("gw27g"));
        case 'es':
            return (parcelRequire("hPFVV"));
        case 'fi':
            return (parcelRequire("c48tL"));
        case 'fr':
            return (parcelRequire("8rLab"));
        case 'hr':
            return (parcelRequire("iDZ6r"));
        case 'hu':
            return (parcelRequire("6GBiF"));
        case 'it':
            return (parcelRequire("5rzfT"));
        case 'ja':
            return (parcelRequire("9H5t3"));
        case 'ko':
            return (parcelRequire("cJ8kD"));
        case 'nb':
            return (parcelRequire("1qzHb"));
        case 'nl':
            return (parcelRequire("b3zUj"));
        case 'pl':
            return (parcelRequire("aUMmf"));
        case 'pt-BR':
            return (parcelRequire("4yAGh"));
        case 'ru':
            return (parcelRequire("8Byjr"));
        case 'sl':
            return (parcelRequire("bBFvp"));
        case 'sr-RS':
            return (parcelRequire("2d5wV"));
        case 'sr-YR':
            return (parcelRequire("6SY8G"));
        case 'sv':
            return (parcelRequire("bLuDl"));
        case 'th':
            return (parcelRequire("9Qtgf"));
        case 'tr':
            return (parcelRequire("6zJaF"));
        case 'uk':
            return (parcelRequire("JefLG"));
        case 'vi':
            return (parcelRequire("ghYSk"));
        case 'zh':
            return (parcelRequire("14lyS"));
        case 'zh-TW':
            return (parcelRequire("16Ykk"));
        default:
            throw new Error(`Unsupported locale: ${locale}`);
    }
};
const $4075999b3649cf1b$export$5a273d9d0fbe2c42 = (requestedLocale)=>{
    try {
        const normalizedLocale = requestedLocale.replace(/_/g, '-');
        const matched = (0, $16f0348bf660d3ef$export$4659b591c19bdf3d)([
            normalizedLocale
        ], [
            ...$4075999b3649cf1b$export$85dea20acc0c2b17
        ], 'en', {
            algorithm: 'best fit'
        });
        if ($4075999b3649cf1b$var$isAvailableLocale(matched)) return matched;
        return 'en';
    } catch (error) {
        return 'en';
    }
};
// Keys that need HTML entity and apostrophe normalization across ALL locales
const $4075999b3649cf1b$var$KEYS_TO_NORMALIZE_ALL_LOCALES = [
    'twc.xflow.modal.legal.noPaymentDetailsLegalTextStandard',
    'twc.xflow.modal.legal.noPaymentDetailsLegalTextPremium',
    'twc.xflow.modal.legal.paymentDetailsLegalText'
];
const $4075999b3649cf1b$var$LOCALE_SPECIFIC_NORMALIZATIONS = {
    it: [
        'twc.xflow.modal.rovo.description'
    ]
};
const $4075999b3649cf1b$var$normalizeMessagesForLocale = (messages, locale)=>{
    const keysToNormalize = new Set([
        ...$4075999b3649cf1b$var$KEYS_TO_NORMALIZE_ALL_LOCALES,
        ...$4075999b3649cf1b$var$LOCALE_SPECIFIC_NORMALIZATIONS[locale] || []
    ]);
    const normalized = {
        ...messages
    };
    keysToNormalize.forEach((key)=>{
        if (typeof normalized[key] === 'string') normalized[key] = $4075999b3649cf1b$export$b014e1744f82778b(normalized[key]);
    });
    return normalized;
};
const $4075999b3649cf1b$export$5ad1685e25d6394f = async (requestedLocale)=>{
    const matchedLocale = $4075999b3649cf1b$export$5a273d9d0fbe2c42(requestedLocale);
    try {
        const localeModule = await $4075999b3649cf1b$var$importLocaleMessages(matchedLocale);
        const messages = localeModule.default || {};
        return {
            locale: matchedLocale,
            messages: $4075999b3649cf1b$var$normalizeMessagesForLocale(messages, matchedLocale)
        };
    } catch (error) {
        // Fallback to English if anything goes wrong
        if (matchedLocale !== 'en') try {
            const enModule = await $4075999b3649cf1b$var$importLocaleMessages('en');
            const messages = enModule.default || {};
            return {
                locale: 'en',
                messages: $4075999b3649cf1b$var$normalizeMessagesForLocale(messages, 'en')
            };
        } catch  {
            return {
                locale: 'en',
                messages: {}
            };
        }
        return {
            locale: 'en',
            messages: {}
        };
    }
};
const $4075999b3649cf1b$export$4d17e2d9c5348842 = (requestedLocale)=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [intlData, setIntlData] = (0, $42omo.useState)({
        locale: 'en',
        messages: {}
    });
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const fetchMessages = async ()=>{
            setIsLoading(true);
            try {
                const data = await $4075999b3649cf1b$export$5ad1685e25d6394f(requestedLocale);
                if (isMounted) setIntlData(data);
            } catch (error) {
                if (isMounted) setIntlData({
                    locale: 'en',
                    messages: {}
                });
            } finally{
                if (isMounted) setIsLoading(false);
            }
        };
        fetchMessages();
        return ()=>{
            isMounted = false;
        };
    }, [
        requestedLocale
    ]);
    return {
        isLoading: isLoading,
        locale: intlData.locale,
        messages: intlData.messages
    };
};






const $cb10290f93fb950e$var$XFLOW_BASE_URL = '/gateway/api/xflow';
const $cb10290f93fb950e$export$7c3012a780e04d56 = async (cloudId, edition, requestTrialCommentText)=>{
    try {
        const cloudInstance = window.location.origin;
        const response = await fetch(`${$cb10290f93fb950e$var$XFLOW_BASE_URL}/${encodeURIComponent(cloudId)}/send-request-trial/teamwork-collection`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                cloud_instance: cloudInstance,
                requested_access_comment_text: requestTrialCommentText,
                is_cross_sell: false,
                edition: edition || '',
                migration_source_uuid: ''
            })
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    } catch (error) {
        (0, $kDHbX.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'send-request-trial',
                packageName: '@atlassian/twc-xflow-modal',
                teamName: 'starburst'
            },
            attributes: {
                cloudId: cloudId
            }
        });
        throw error;
    }
};


const $4cac346414ecddf4$var$styles = {
    modalWrapper: "_1reo15vq _18m915vq _2rko12b0 _kqswh2mm _1bsb1osq _p12f1qhy _1tke1oh5"
};
const $4cac346414ecddf4$var$TwcXflowModal = ({ onClose: onClose, onComplete: onComplete, onTryNowClick: onTryNowClick, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId, sourceComponent: sourceComponent, sourceContext: sourceContext, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, modalState: modalState, redirectUrl: redirectUrl, setRedirectUrl: setRedirectUrl, isNormalizeSeatsEnabled: isNormalizeSeatsEnabled } = (0, $c7f0819402fcc1f3$export$4cc1699d46f42cae)();
    const [approvalUrl, setApprovalUrl] = (0, $42omo.useState)(undefined);
    const canActivate = (0, $42omo.useMemo)(()=>modalState.activationCapability === 'can-activate', [
        modalState.activationCapability
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!cloudId) setCurrentScreen('error');
    }, [
        cloudId,
        setCurrentScreen
    ]);
    const handleTryNowClick = (0, $42omo.useCallback)(()=>{
        onTryNowClick?.();
        if (canActivate) {
            setCurrentScreen('provisioning');
            return;
        } else {
            const [hasRequested, requestedTrialData] = (0, $eaffa4b1a723cea5$export$45e741e8e28c95c2)(cloudId);
            if (hasRequested) {
                setApprovalUrl(requestedTrialData.link);
                setCurrentScreen('requested-trial-screen');
                return;
            } else (0, $cb10290f93fb950e$export$7c3012a780e04d56)(cloudId, modalState.edition, formatMessage((0, $67f905b5cc424541$export$defe85febe8b728c).requestTrialComment)).then((response)=>{
                if (response?.approvalUrl) {
                    (0, $eaffa4b1a723cea5$export$c9afdcd809810038)(cloudId, response.approvalUrl);
                    setApprovalUrl(response.approvalUrl);
                }
                setCurrentScreen('requested-trial-screen');
            }).catch(()=>{
                setCurrentScreen('error');
            });
        }
    }, [
        setCurrentScreen,
        onTryNowClick,
        modalState.edition,
        cloudId,
        canActivate,
        formatMessage
    ]);
    const handleProvisioningComplete = (0, $42omo.useCallback)((redirectUrl)=>{
        redirectUrl && setRedirectUrl(redirectUrl);
        setCurrentScreen('welcome');
    }, [
        setCurrentScreen,
        setRedirectUrl
    ]);
    const handleWelcomeComplete = (0, $42omo.useCallback)(()=>{
        if ((0, $dh538.fg)('twc_normalize_seat_modal_gate_v2')) setCurrentScreen('normalize-seat');
        else {
            onComplete?.();
            window.location.href = redirectUrl;
        }
    }, [
        setCurrentScreen,
        redirectUrl,
        onComplete
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalClose',
            attributes: {
                currentScreen: currentScreen,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
        onClose();
    }, [
        currentScreen,
        onClose,
        createAnalyticsEvent,
        sourceComponent,
        sourceContext
    ]);
    const handleNormalizeComplete = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcXflowModalNormalizeSeatConfirm',
            source: 'twcXflowModalNormalizeSeatScreen',
            attributes: {
                isNormalizeSeatsEnabled: isNormalizeSeatsEnabled,
                edition: modalState.edition,
                hasPaymentDetails: modalState.hasPaymentDetails,
                userProducts: modalState.userProducts,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext
            }
        }).fire('growth');
        if (isNormalizeSeatsEnabled) try {
            await (0, $c175f2a7ad162fe0$export$a954a840fe6f9c7e)({
                cloudId: cloudId
            });
            createAnalyticsEvent({
                eventType: 'track',
                action: 'normalizeSeatStarted',
                actionSubject: 'normalizeSeatJob',
                actionSubjectId: 'twcXflowModal',
                attributes: {
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext
                }
            }).fire('growth');
        } catch  {
            createAnalyticsEvent({
                eventType: 'track',
                action: 'normalizeSeatStartFailed',
                actionSubject: 'normalizeSeatJob',
                actionSubjectId: 'twcXflowModal',
                attributes: {
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext
                }
            }).fire('growth');
        }
        onComplete?.();
        window.location.href = redirectUrl;
    }, [
        isNormalizeSeatsEnabled,
        cloudId,
        redirectUrl,
        createAnalyticsEvent,
        modalState,
        onComplete,
        sourceComponent,
        sourceContext
    ]);
    const { subheader: confirmationSubheaderV2, ctaText: confirmationCtaTextV2 } = (0, $43f3976b30aa2a96$export$36750747069c3e29)({
        edition: modalState.edition,
        activationCapability: modalState.activationCapability,
        hasPaymentDetails: modalState.hasPaymentDetails
    });
    const renderScreen = ()=>{
        switch(currentScreen){
            case 'loading':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $9a2d95c7a8f18111$export$e2b0760399e6dece), {
                    setApprovalUrl: setApprovalUrl
                });
            case 'error':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $5867abb547886a50$export$42f84e610f279c31), {
                    onClose: handleOnClose
                });
            case 'confirmation':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ac1e78a9b56061c3$export$88ff240c67647cf0), {
                    onTryNowClick: handleTryNowClick,
                    onClose: handleOnClose,
                    canActivate: canActivate,
                    edition: modalState.edition,
                    hasPaymentDetails: modalState.hasPaymentDetails,
                    confirmationSubheader: confirmationSubheaderV2,
                    confirmationCtaText: confirmationCtaTextV2
                });
            case 'provisioning':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $0b63c77697f022bc$export$ebb96ceb0e1178aa), {
                    onProvisioningComplete: handleProvisioningComplete
                });
            case 'welcome':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $dba47e467632c0bf$export$8995dcca99dcdafc), {
                    onComplete: handleWelcomeComplete
                });
            case 'normalize-seat':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $15b6b1b5c59c03a0$export$db80c0ce62bed0a3), {
                    onConfirm: handleNormalizeComplete,
                    testId: testId
                });
            case 'requested-trial-screen':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $c383c647cfd75ecd$export$164db6a68b9a95ea), {
                    onClose: handleOnClose,
                    approvalUrl: approvalUrl
                });
            case 'timeout':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $9a81940be631c59d$export$a15a7b5fa3fb3a75), {
                    onClose: handleOnClose
                });
        }
    };
    const shouldAllowClose = currentScreen === 'error' || currentScreen === 'confirmation' || currentScreen === 'loading' || currentScreen === 'requested-trial-screen' || currentScreen === 'timeout';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            shouldCloseOnOverlayClick: shouldAllowClose,
            shouldCloseOnEscapePress: shouldAllowClose,
            onClose: handleOnClose,
            testId: testId,
            width: "x-large",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4cac346414ecddf4$var$styles.modalWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
                    FallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5867abb547886a50$export$42f84e610f279c31), {
                            onClose: handleOnClose
                        }),
                    onError: (error)=>{
                        (0, $kDHbX.captureException)('Unhandled error in TWC XFlow modal', error, {
                            cloudId: cloudId,
                            packageName: '@atlassian/twc-xflow-modal',
                            teamName: 'starburst'
                        });
                    },
                    children: renderScreen()
                })
            })
        })
    });
};
const $4cac346414ecddf4$var$TwcXflowModalWithoutMessages = (props)=>{
    const { cloudId: cloudId, sourceComponent: sourceComponent, sourceContext: sourceContext, onClose: onClose, onComplete: onComplete, onTryNowClick: onTryNowClick, testId: testId, orgId: orgId } = props;
    const contextValue = (0, $c7f0819402fcc1f3$export$baa48889c42cc6cb)(cloudId, sourceComponent, sourceContext, 'en', orgId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c7f0819402fcc1f3$export$178405afcd8c5eb), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
            locale: 'en',
            children: /*#__PURE__*/ (0, $l998X.jsx)($4cac346414ecddf4$var$TwcXflowModal, {
                onClose: onClose,
                onComplete: onComplete,
                onTryNowClick: onTryNowClick,
                testId: testId
            })
        })
    });
};
const $4cac346414ecddf4$var$TwcXflowModalWithMessages = (props)=>{
    const { locale: requestedLocale = 'en', cloudId: cloudId, sourceComponent: sourceComponent, sourceContext: sourceContext, onClose: onClose, onComplete: onComplete, onTryNowClick: onTryNowClick, testId: testId, orgId: orgId } = props;
    const { isLoading: isLoading, locale: locale, messages: messages } = (0, $4075999b3649cf1b$export$4d17e2d9c5348842)(requestedLocale);
    const contextValue = (0, $c7f0819402fcc1f3$export$baa48889c42cc6cb)(cloudId, sourceComponent, sourceContext, locale, orgId);
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c7f0819402fcc1f3$export$178405afcd8c5eb), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
            locale: locale,
            messages: messages,
            children: /*#__PURE__*/ (0, $l998X.jsx)($4cac346414ecddf4$var$TwcXflowModal, {
                onClose: onClose,
                onComplete: onComplete,
                onTryNowClick: onTryNowClick,
                testId: testId
            })
        })
    });
};
var $4cac346414ecddf4$export$2e2bcd8739ae039 = (0, $bedQP.componentWithFG)('grw-twc-skip-locale-check', $4cac346414ecddf4$var$TwcXflowModalWithMessages, $4cac346414ecddf4$var$TwcXflowModalWithoutMessages);

});

parcelRegister("9KJ3M", function(module, exports) {

let $719b5ce954eb5a30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $719b5ce954eb5a30$var$load("3EtHp").then(()=>parcelRequire('jMsOp'));

});

parcelRegister("eahLs", function(module, exports) {

let $a4ffc77d444ca558$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4ffc77d444ca558$var$load("9m8Nr").then(()=>parcelRequire('8IycQ'));

});

parcelRegister("3oQfv", function(module, exports) {

let $279c2492e7fba648$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $279c2492e7fba648$var$load("4E6dy").then(()=>parcelRequire('euq81'));

});

parcelRegister("3yhHL", function(module, exports) {

let $296247e0a143a41f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $296247e0a143a41f$var$load("8JoSD").then(()=>parcelRequire('5KdVD'));

});

parcelRegister("bVIrE", function(module, exports) {

let $8af77e693dcb66fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8af77e693dcb66fa$var$load("bAOHw").then(()=>parcelRequire('zbUEG'));

});

parcelRegister("3Bd6r", function(module, exports) {

let $29eefdc18a227aab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29eefdc18a227aab$var$load("h3G5z").then(()=>parcelRequire('hw5JB'));

});

parcelRegister("iA2ey", function(module, exports) {

let $d86d525b57b4937d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d86d525b57b4937d$var$load("gNA0J").then(()=>parcelRequire('92vtm'));

});

parcelRegister("6TBrL", function(module, exports) {

let $5054ed4c82765dab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5054ed4c82765dab$var$load("9kjAa").then(()=>parcelRequire('6B6ns'));

});

parcelRegister("depve", function(module, exports) {

let $9a205d7d9b9bf03e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a205d7d9b9bf03e$var$load("vaHqY").then(()=>parcelRequire('3iyJc'));

});

parcelRegister("gw27g", function(module, exports) {

let $c06146bd209448c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c06146bd209448c2$var$load("hKKq1").then(()=>parcelRequire('gpNfP'));

});

parcelRegister("hPFVV", function(module, exports) {

let $cfb7ba238449f872$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfb7ba238449f872$var$load("699rt").then(()=>parcelRequire('5UwKm'));

});

parcelRegister("c48tL", function(module, exports) {

let $8c8c6f856d6811d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c8c6f856d6811d2$var$load("4U6vo").then(()=>parcelRequire('cZTlD'));

});

parcelRegister("8rLab", function(module, exports) {

let $62656e01c77ea6ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62656e01c77ea6ea$var$load("8bauW").then(()=>parcelRequire('jx9hn'));

});

parcelRegister("iDZ6r", function(module, exports) {

let $d92b4440414cc4f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d92b4440414cc4f2$var$load("2XHsa").then(()=>parcelRequire('fgJH8'));

});

parcelRegister("6GBiF", function(module, exports) {

let $4de3995af03cba28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4de3995af03cba28$var$load("fQ6gV").then(()=>parcelRequire('ge9wN'));

});

parcelRegister("5rzfT", function(module, exports) {

let $3f6ad254a26b4aeb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f6ad254a26b4aeb$var$load("8N1M8").then(()=>parcelRequire('h0lxf'));

});

parcelRegister("9H5t3", function(module, exports) {

let $70ec5efc45555fac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70ec5efc45555fac$var$load("64SZl").then(()=>parcelRequire('1xpLq'));

});

parcelRegister("cJ8kD", function(module, exports) {

let $94402689398543d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94402689398543d4$var$load("l9rrS").then(()=>parcelRequire('etmfr'));

});

parcelRegister("1qzHb", function(module, exports) {

let $10a3e88919527152$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10a3e88919527152$var$load("1K1DB").then(()=>parcelRequire('bdqnW'));

});

parcelRegister("b3zUj", function(module, exports) {

let $80cbd3f292d83a31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80cbd3f292d83a31$var$load("2IhWo").then(()=>parcelRequire('drBgc'));

});

parcelRegister("aUMmf", function(module, exports) {

let $7f24a53006fbd5a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f24a53006fbd5a8$var$load("cB5tA").then(()=>parcelRequire('c8omt'));

});

parcelRegister("4yAGh", function(module, exports) {

let $3516ca7b8e14086d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3516ca7b8e14086d$var$load("14y9P").then(()=>parcelRequire('gC4IP'));

});

parcelRegister("8Byjr", function(module, exports) {

let $643c6530ea5d052a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $643c6530ea5d052a$var$load("8BgQU").then(()=>parcelRequire('iXeKI'));

});

parcelRegister("bBFvp", function(module, exports) {

let $8733588f753c1d4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8733588f753c1d4a$var$load("kyH38").then(()=>parcelRequire('le11U'));

});

parcelRegister("2d5wV", function(module, exports) {

let $19c115d72a253e17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19c115d72a253e17$var$load("b8zkJ").then(()=>parcelRequire('8nqF2'));

});

parcelRegister("6SY8G", function(module, exports) {

let $50366f94c8a806f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50366f94c8a806f1$var$load("2Ypcl").then(()=>parcelRequire('15naX'));

});

parcelRegister("bLuDl", function(module, exports) {

let $890bd8ade33f0149$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $890bd8ade33f0149$var$load("g5vt7").then(()=>parcelRequire('gySGk'));

});

parcelRegister("9Qtgf", function(module, exports) {

let $72afab00871fe498$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72afab00871fe498$var$load("aUgRr").then(()=>parcelRequire('phHIc'));

});

parcelRegister("6zJaF", function(module, exports) {

let $4c990cff623dc6c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c990cff623dc6c8$var$load("dZlmW").then(()=>parcelRequire('5Zpc3'));

});

parcelRegister("JefLG", function(module, exports) {

let $087f427f5f41358b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $087f427f5f41358b$var$load("dP9AS").then(()=>parcelRequire('hBv5O'));

});

parcelRegister("ghYSk", function(module, exports) {

let $bdbd747434bfb21c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdbd747434bfb21c$var$load("7yahE").then(()=>parcelRequire('aDC3u'));

});

parcelRegister("14lyS", function(module, exports) {

let $0c76e3daf3b1f3f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c76e3daf3b1f3f1$var$load("kXGHC").then(()=>parcelRequire('i72im'));

});

parcelRegister("16Ykk", function(module, exports) {

let $0cf525aa2ef78e09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cf525aa2ef78e09$var$load("aparn").then(()=>parcelRequire('gztHl'));

});

parcelRegister("1sDXW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jSpMW = parcelRequire("jSpMW");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $kpYGL = parcelRequire("kpYGL");

const $493987553a45848f$var$styles = {
    container: "_kqswh2mm",
    contentContainer: "_v56414fr",
    contentVisible: "_tzy4kb7n",
    contentHidden: "_tzy4idpf",
    skeletonContainer: "_v56414fr _kqswstnw _154iidpf _1ltvidpf",
    skeletonVisible: "_tzy4kb7n",
    skeletonHidden: "_tzy4idpf"
};
const $493987553a45848f$export$8f31e4c4a37b8e9c = ({ children: children, isLoading: isLoading, width: width = '100%', height: height = '100%' })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $493987553a45848f$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($493987553a45848f$var$styles.skeletonContainer, isLoading ? $493987553a45848f$var$styles.skeletonVisible : $493987553a45848f$var$styles.skeletonHidden),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    height: height,
                    width: width,
                    isShimmering: true
                })
            }),
            !isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($493987553a45848f$var$styles.contentContainer, $493987553a45848f$var$styles.contentVisible),
                children: children
            }) : null
        ]
    });
};
const $493987553a45848f$export$e29046836bef91f7 = ({ lottieProps: lottieProps })=>{
    const isLoading = !lottieProps.animationData;
    return /*#__PURE__*/ (0, $l998X.jsx)($493987553a45848f$export$8f31e4c4a37b8e9c, {
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSpMW))), {
            ...lottieProps
        })
    });
};
module.exports["Skeleton"] = $493987553a45848f$export$8f31e4c4a37b8e9c;

});

parcelRegister("a48Rq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $d735fe13c27cabec$export$d4be75c847b4615a = (loadLightAnimation, loadDarkAnimation, onError)=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [animationData, setAnimationData] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        let isCancelled = false;
        const loadAnimation = async ()=>{
            try {
                const data = colorMode === 'dark' ? await loadDarkAnimation() : await loadLightAnimation();
                if (!isCancelled) setAnimationData(data);
            } catch (error) {
                if (!isCancelled) onError?.(error);
            }
        };
        if (!colorMode) return;
        loadAnimation();
        return ()=>{
            isCancelled = true;
        };
    }, [
        colorMode,
        loadLightAnimation,
        loadDarkAnimation,
        onError
    ]);
    return animationData;
};
module.exports["useThemeAnimation"] = $d735fe13c27cabec$export$d4be75c847b4615a;

});

parcelRegister("eKeqs", function(module, exports) {

var $gmi2s = parcelRequire("gmi2s");

function $15945eb408849de0$export$9090741f5986ef95(availableLocales, requestedLocales, getDefaultLocale) {
    var foundLocale;
    var extension;
    var noExtensionLocales = [];
    var noExtensionLocaleMap = requestedLocales.reduce(function(all, l) {
        var noExtensionLocale = l.replace((0, $gmi2s.UNICODE_EXTENSION_SEQUENCE_REGEX), '');
        noExtensionLocales.push(noExtensionLocale);
        all[noExtensionLocale] = l;
        return all;
    }, {});
    var result = (0, $gmi2s.findBestMatch)(noExtensionLocales, availableLocales);
    if (result.matchedSupportedLocale && result.matchedDesiredLocale) {
        foundLocale = result.matchedSupportedLocale;
        extension = noExtensionLocaleMap[result.matchedDesiredLocale].slice(result.matchedDesiredLocale.length) || undefined;
    }
    if (!foundLocale) return {
        locale: getDefaultLocale()
    };
    return {
        locale: foundLocale,
        extension: extension
    };
}





function $e90b3c016a285c1a$export$557711f94602707f(ukey, uvalue) {
    // TODO: Implement algorithm for CanonicalizeUValue per https://tc39.es/ecma402/#sec-canonicalizeuvalue
    var lowerValue = uvalue.toLowerCase();
    (0, $gmi2s.invariant)(ukey !== undefined, "ukey must be defined");
    var canonicalized = lowerValue;
    return canonicalized;
}


function $fb709b7f2781f7b6$export$c209325161c174e5(locale) {
    return Intl.getCanonicalLocales(locale)[0];
}





function $109fb2ab301f7432$export$d231d36dc88a3306(locale, attributes, keywords) {
    (0, $gmi2s.invariant)(locale.indexOf('-u-') === -1, 'Expected locale to not have a Unicode locale extension');
    var extension = '-u';
    for(var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++){
        var attr = attributes_1[_i];
        extension += "-".concat(attr);
    }
    for(var _a = 0, keywords_1 = keywords; _a < keywords_1.length; _a++){
        var kw = keywords_1[_a];
        var key = kw.key, value = kw.value;
        extension += "-".concat(key);
        if (value !== '') extension += "-".concat(value);
    }
    if (extension === '-u') return (0, $fb709b7f2781f7b6$export$c209325161c174e5)(locale);
    var privateIndex = locale.indexOf('-x-');
    var newLocale;
    if (privateIndex === -1) newLocale = locale + extension;
    else {
        var preExtension = locale.slice(0, privateIndex);
        var postExtension = locale.slice(privateIndex);
        newLocale = preExtension + extension + postExtension;
    }
    return (0, $fb709b7f2781f7b6$export$c209325161c174e5)(newLocale);
}



var $e0bwv = parcelRequire("e0bwv");




function $9fadd241337795b8$export$89f26809a129249d(availableLocales, requestedLocales, getDefaultLocale) {
    var result = {
        locale: ''
    };
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace((0, $gmi2s.UNICODE_EXTENSION_SEQUENCE_REGEX), '');
        var availableLocale = (0, $e0bwv.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) result.extension = locale.slice(noExtensionLocale.length, locale.length);
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}





function $5dbf88529d595557$export$16d873f9372213dc(extension) {
    (0, $gmi2s.invariant)(extension === extension.toLowerCase(), 'Expected extension to be lowercase');
    (0, $gmi2s.invariant)(extension.slice(0, 3) === '-u-', 'Expected extension to be a Unicode locale extension');
    var attributes = [];
    var keywords = [];
    var keyword;
    var size = extension.length;
    var k = 3;
    while(k < size){
        var e = extension.indexOf('-', k);
        var len = void 0;
        if (e === -1) len = size - k;
        else len = e - k;
        var subtag = extension.slice(k, k + len);
        (0, $gmi2s.invariant)(len >= 2, 'Expected a subtag to have at least 2 characters');
        if (keyword === undefined && len != 2) {
            if (attributes.indexOf(subtag) === -1) attributes.push(subtag);
        } else if (len === 2) {
            keyword = {
                key: subtag,
                value: ''
            };
            if (keywords.find(function(k) {
                return k.key === (keyword === null || keyword === void 0 ? void 0 : keyword.key);
            }) === undefined) keywords.push(keyword);
        } else if ((keyword === null || keyword === void 0 ? void 0 : keyword.value) === '') keyword.value = subtag;
        else {
            (0, $gmi2s.invariant)(keyword !== undefined, 'Expected keyword to be defined');
            keyword.value += '-' + subtag;
        }
        k += len + 1;
    }
    return {
        attributes: attributes,
        keywords: keywords
    };
}





function $abc08d36f6cb6cb6$export$eda5c489927dff5c(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var _a;
    var matcher = options.localeMatcher;
    var r;
    if (matcher === 'lookup') r = (0, $9fadd241337795b8$export$89f26809a129249d)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    else r = (0, $15945eb408849de0$export$9090741f5986ef95)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    if (r == null) r = {
        locale: getDefaultLocale(),
        extension: ''
    };
    var foundLocale = r.locale;
    var foundLocaleData = localeData[foundLocale];
    // TODO: We can't really guarantee that the locale data is available
    // invariant(
    //   foundLocaleData !== undefined,
    //   `Missing locale data for ${foundLocale}`
    // )
    var result = {
        locale: 'en',
        dataLocale: foundLocale
    };
    var components;
    var keywords;
    if (r.extension) {
        components = (0, $5dbf88529d595557$export$16d873f9372213dc)(r.extension);
        keywords = components.keywords;
    } else keywords = [];
    var supportedKeywords = [];
    var _loop_1 = function(key) {
        // TODO: Shouldn't default to empty array, see TODO above
        var keyLocaleData = (_a = foundLocaleData === null || foundLocaleData === void 0 ? void 0 : foundLocaleData[key]) !== null && _a !== void 0 ? _a : [];
        (0, $gmi2s.invariant)(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
        var value = keyLocaleData[0];
        (0, $gmi2s.invariant)(value === undefined || typeof value === 'string', "value must be a string or undefined");
        var supportedKeyword = void 0;
        var entry = keywords.find(function(k) {
            return k.key === key;
        });
        if (entry) {
            var requestedValue = entry.value;
            if (requestedValue !== '') {
                if (keyLocaleData.indexOf(requestedValue) > -1) {
                    value = requestedValue;
                    supportedKeyword = {
                        key: key,
                        value: value
                    };
                }
            } else if (keyLocaleData.indexOf('true') > -1) {
                value = 'true';
                supportedKeyword = {
                    key: key,
                    value: value
                };
            }
        }
        var optionsValue = options[key];
        (0, $gmi2s.invariant)(optionsValue == null || typeof optionsValue === 'string', "optionsValue must be a string or undefined");
        if (typeof optionsValue === 'string') {
            var ukey = key.toLowerCase();
            optionsValue = (0, $e90b3c016a285c1a$export$557711f94602707f)(ukey, optionsValue);
            if (optionsValue === '') optionsValue = 'true';
        }
        if (optionsValue !== value && keyLocaleData.indexOf(optionsValue) > -1) {
            value = optionsValue;
            supportedKeyword = undefined;
        }
        if (supportedKeyword) supportedKeywords.push(supportedKeyword);
        result[key] = value;
    };
    for(var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++){
        var key = relevantExtensionKeys_1[_i];
        _loop_1(key);
    }
    var supportedAttributes = [];
    if (supportedKeywords.length > 0) {
        supportedAttributes = [];
        foundLocale = (0, $109fb2ab301f7432$export$d231d36dc88a3306)(foundLocale, supportedAttributes, supportedKeywords);
    }
    result.locale = foundLocale;
    return result;
}
module.exports["ResolveLocale"] = $abc08d36f6cb6cb6$export$eda5c489927dff5c;

});

parcelRegister("lP6Yy", function(module, exports) {

var $e0bwv = parcelRequire("e0bwv");


var $gmi2s = parcelRequire("gmi2s");

function $fe33c59f328dec9b$export$c8d4643f0fa81556(availableLocales, requestedLocales) {
    var subset = [];
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace((0, $gmi2s.UNICODE_EXTENSION_SEQUENCE_REGEX), '');
        var availableLocale = (0, $e0bwv.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) subset.push(availableLocale);
    }
    return subset;
}

});

parcelRegister("e0bwv", function(module, exports) {
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */ function $a31a010d7e17a8a2$export$1d370a586a140c95(availableLocales, locale) {
    var candidate = locale;
    while(true){
        if (availableLocales.indexOf(candidate) > -1) return candidate;
        var pos = candidate.lastIndexOf('-');
        if (!~pos) return undefined;
        if (pos >= 2 && candidate[pos - 2] === '-') pos -= 2;
        candidate = candidate.slice(0, pos);
    }
}
module.exports["BestAvailableLocale"] = $a31a010d7e17a8a2$export$1d370a586a140c95;

});

parcelRegister("gmi2s", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $1EYYA = parcelRequire("1EYYA");


var $poqQX = parcelRequire("poqQX");

var $be8cb18654f960b3$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $be8cb18654f960b3$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
// This is effectively 2 languages in 2 different regions in the same cluster
var $be8cb18654f960b3$var$DEFAULT_MATCHING_THRESHOLD = 838;
var $be8cb18654f960b3$var$PROCESSED_DATA;
function $be8cb18654f960b3$var$processData() {
    var _a, _b;
    if (!$be8cb18654f960b3$var$PROCESSED_DATA) {
        var paradigmLocales = (_b = (_a = (0, $1EYYA.data).supplemental.languageMatching['written-new'][0]) === null || _a === void 0 ? void 0 : _a.paradigmLocales) === null || _b === void 0 ? void 0 : _b._locales.split(' ');
        var matchVariables = (0, $1EYYA.data).supplemental.languageMatching['written-new'].slice(1, 5);
        var data = (0, $1EYYA.data).supplemental.languageMatching['written-new'].slice(5);
        var matches = data.map(function(d) {
            var key = Object.keys(d)[0];
            var value = d[key];
            return {
                supported: key,
                desired: value._desired,
                distance: +value._distance,
                oneway: value.oneway === 'true' ? true : false
            };
        }, {});
        $be8cb18654f960b3$var$PROCESSED_DATA = {
            matches: matches,
            matchVariables: matchVariables.reduce(function(all, d) {
                var key = Object.keys(d)[0];
                var value = d[key];
                all[key.slice(1)] = value._value.split('+');
                return all;
            }, {}),
            paradigmLocales: (0, $hXuPC.__spreadArray)((0, $hXuPC.__spreadArray)([], paradigmLocales, true), paradigmLocales.map(function(l) {
                return new Intl.Locale(l.replace(/_/g, '-')).maximize().toString();
            }), true)
        };
    }
    return $be8cb18654f960b3$var$PROCESSED_DATA;
}
function $be8cb18654f960b3$var$isMatched(locale, languageMatchInfoLocale, matchVariables) {
    var _a = languageMatchInfoLocale.split('-'), language = _a[0], script = _a[1], region = _a[2];
    var matches = true;
    if (region && region[0] === '$') {
        var shouldInclude = region[1] !== '!';
        var matchRegions = shouldInclude ? matchVariables[region.slice(1)] : matchVariables[region.slice(2)];
        var expandedMatchedRegions = matchRegions.map(function(r) {
            return (0, $poqQX.regions)[r] || [
                r
            ];
        }).reduce(function(all, list) {
            return (0, $hXuPC.__spreadArray)((0, $hXuPC.__spreadArray)([], all, true), list, true);
        }, []);
        matches && (matches = !(expandedMatchedRegions.indexOf(locale.region || '') > 1 != shouldInclude));
    } else matches && (matches = locale.region ? region === '*' || region === locale.region : true);
    matches && (matches = locale.script ? script === '*' || script === locale.script : true);
    matches && (matches = locale.language ? language === '*' || language === locale.language : true);
    return matches;
}
function $be8cb18654f960b3$var$serializeLSR(lsr) {
    return [
        lsr.language,
        lsr.script,
        lsr.region
    ].filter(Boolean).join('-');
}
function $be8cb18654f960b3$var$findMatchingDistanceForLSR(desired, supported, data) {
    for(var _i = 0, _a = data.matches; _i < _a.length; _i++){
        var d = _a[_i];
        var matches = $be8cb18654f960b3$var$isMatched(desired, d.desired, data.matchVariables) && $be8cb18654f960b3$var$isMatched(supported, d.supported, data.matchVariables);
        if (!d.oneway && !matches) matches = $be8cb18654f960b3$var$isMatched(desired, d.supported, data.matchVariables) && $be8cb18654f960b3$var$isMatched(supported, d.desired, data.matchVariables);
        if (matches) {
            var distance = d.distance * 10;
            if (data.paradigmLocales.indexOf($be8cb18654f960b3$var$serializeLSR(desired)) > -1 != data.paradigmLocales.indexOf($be8cb18654f960b3$var$serializeLSR(supported)) > -1) return distance - 1;
            return distance;
        }
    }
    throw new Error('No matching distance found');
}
function $be8cb18654f960b3$export$cbd58ee0ecb233c(desired, supported) {
    var desiredLocale = new Intl.Locale(desired).maximize();
    var supportedLocale = new Intl.Locale(supported).maximize();
    var desiredLSR = {
        language: desiredLocale.language,
        script: desiredLocale.script || '',
        region: desiredLocale.region || ''
    };
    var supportedLSR = {
        language: supportedLocale.language,
        script: supportedLocale.script || '',
        region: supportedLocale.region || ''
    };
    var matchingDistance = 0;
    var data = $be8cb18654f960b3$var$processData();
    if (desiredLSR.language !== supportedLSR.language) matchingDistance += $be8cb18654f960b3$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: '',
        region: ''
    }, {
        language: supportedLocale.language,
        script: '',
        region: ''
    }, data);
    if (desiredLSR.script !== supportedLSR.script) matchingDistance += $be8cb18654f960b3$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: desiredLSR.script,
        region: ''
    }, {
        language: supportedLocale.language,
        script: desiredLSR.script,
        region: ''
    }, data);
    if (desiredLSR.region !== supportedLSR.region) matchingDistance += $be8cb18654f960b3$var$findMatchingDistanceForLSR(desiredLSR, supportedLSR, data);
    return matchingDistance;
}
function $be8cb18654f960b3$export$eb706e1d1a6ed33f(requestedLocales, supportedLocales, threshold) {
    if (threshold === void 0) threshold = $be8cb18654f960b3$var$DEFAULT_MATCHING_THRESHOLD;
    var lowestDistance = Infinity;
    var result = {
        matchedDesiredLocale: '',
        distances: {}
    };
    requestedLocales.forEach(function(desired, i) {
        if (!result.distances[desired]) result.distances[desired] = {};
        supportedLocales.forEach(function(supported) {
            // Add some weight to the distance based on the order of the supported locales
            // Add penalty for the order of the requested locales, which currently is 0 since ECMA-402
            // doesn't really have room for weighted locales like `en; q=0.1`
            var distance = $be8cb18654f960b3$export$cbd58ee0ecb233c(desired, supported) + 0 + i * 40;
            result.distances[desired][supported] = distance;
            if (distance < lowestDistance) {
                lowestDistance = distance;
                result.matchedDesiredLocale = desired;
                result.matchedSupportedLocale = supported;
            }
        });
    });
    if (lowestDistance >= threshold) {
        result.matchedDesiredLocale = undefined;
        result.matchedSupportedLocale = undefined;
    }
    return result;
}
module.exports["UNICODE_EXTENSION_SEQUENCE_REGEX"] = $be8cb18654f960b3$export$9049a02e759202e4;
module.exports["invariant"] = $be8cb18654f960b3$export$f5708dca728d7177;
module.exports["findBestMatch"] = $be8cb18654f960b3$export$eb706e1d1a6ed33f;

});

parcelRegister("1EYYA", function(module, exports) {
var $1358d37e8935a2f6$export$4051a07651545597 = {
    supplemental: {
        languageMatching: {
            'written-new': [
                {
                    paradigmLocales: {
                        _locales: 'en en_GB es es_419 pt_BR pt_PT'
                    }
                },
                {
                    $enUS: {
                        _value: 'AS+CA+GU+MH+MP+PH+PR+UM+US+VI'
                    }
                },
                {
                    $cnsar: {
                        _value: 'HK+MO'
                    }
                },
                {
                    $americas: {
                        _value: '019'
                    }
                },
                {
                    $maghreb: {
                        _value: 'MA+DZ+TN+LY+MR+EH'
                    }
                },
                {
                    no: {
                        _desired: 'nb',
                        _distance: '1'
                    }
                },
                {
                    bs: {
                        _desired: 'hr',
                        _distance: '4'
                    }
                },
                {
                    bs: {
                        _desired: 'sh',
                        _distance: '4'
                    }
                },
                {
                    hr: {
                        _desired: 'sh',
                        _distance: '4'
                    }
                },
                {
                    sr: {
                        _desired: 'sh',
                        _distance: '4'
                    }
                },
                {
                    aa: {
                        _desired: 'ssy',
                        _distance: '4'
                    }
                },
                {
                    de: {
                        _desired: 'gsw',
                        _distance: '4',
                        _oneway: 'true'
                    }
                },
                {
                    de: {
                        _desired: 'lb',
                        _distance: '4',
                        _oneway: 'true'
                    }
                },
                {
                    no: {
                        _desired: 'da',
                        _distance: '8'
                    }
                },
                {
                    nb: {
                        _desired: 'da',
                        _distance: '8'
                    }
                },
                {
                    ru: {
                        _desired: 'ab',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ach',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    nl: {
                        _desired: 'af',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ak',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'am',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    es: {
                        _desired: 'ay',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'az',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ur: {
                        _desired: 'bal',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'be',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'bem',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    hi: {
                        _desired: 'bh',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'bn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'bo',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'br',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    es: {
                        _desired: 'ca',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    fil: {
                        _desired: 'ceb',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'chr',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ckb',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'co',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'crs',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    sk: {
                        _desired: 'cs',
                        _distance: '20'
                    }
                },
                {
                    en: {
                        _desired: 'cy',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ee',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'eo',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    es: {
                        _desired: 'eu',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    da: {
                        _desired: 'fo',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    nl: {
                        _desired: 'fy',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ga',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'gaa',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'gd',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    es: {
                        _desired: 'gl',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    es: {
                        _desired: 'gn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    hi: {
                        _desired: 'gu',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ha',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'haw',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'ht',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'hy',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ia',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ig',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'is',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    id: {
                        _desired: 'jv',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ka',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'kg',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'kk',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'km',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'kn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'kri',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    tr: {
                        _desired: 'ku',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'ky',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    it: {
                        _desired: 'la',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'lg',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'ln',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'lo',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'loz',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'lua',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    hi: {
                        _desired: 'mai',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'mfe',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'mg',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'mi',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ml',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'mn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    hi: {
                        _desired: 'mr',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    id: {
                        _desired: 'ms',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'mt',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'my',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ne',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    nb: {
                        _desired: 'nn',
                        _distance: '20'
                    }
                },
                {
                    no: {
                        _desired: 'nn',
                        _distance: '20'
                    }
                },
                {
                    en: {
                        _desired: 'nso',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ny',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'nyn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'oc',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'om',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'or',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'pa',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'pcm',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ps',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    es: {
                        _desired: 'qu',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    de: {
                        _desired: 'rm',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'rn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'rw',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    hi: {
                        _desired: 'sa',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'sd',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'si',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'sn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'so',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'sq',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'st',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    id: {
                        _desired: 'su',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'sw',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ta',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'te',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'tg',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ti',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'tk',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'tlh',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'tn',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'to',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'tt',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'tum',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'ug',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'uk',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'ur',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ru: {
                        _desired: 'uz',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    fr: {
                        _desired: 'wo',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'xh',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'yi',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'yo',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'za',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    en: {
                        _desired: 'zu',
                        _distance: '30',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'aao',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'abh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'abv',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'acm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'acq',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'acw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'acx',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'acy',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'adf',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'aeb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'aec',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'afb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ajp',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'apc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'apd',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'arq',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ars',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ary',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'arz',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'auz',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'avl',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ayh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ayl',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ayn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ayp',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'bbz',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'pga',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'shu',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ar: {
                        _desired: 'ssh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    az: {
                        _desired: 'azb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    et: {
                        _desired: 'vro',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'ffm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fub',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fue',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fuf',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fuh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fui',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fuq',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ff: {
                        _desired: 'fuv',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    gn: {
                        _desired: 'gnw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    gn: {
                        _desired: 'gui',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    gn: {
                        _desired: 'gun',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    gn: {
                        _desired: 'nhd',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    iu: {
                        _desired: 'ikt',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'enb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'eyo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'niq',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'oki',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'pko',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'sgc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'tec',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kln: {
                        _desired: 'tuy',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kok: {
                        _desired: 'gom',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    kpe: {
                        _desired: 'gkp',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'ida',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lkb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lko',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lks',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lri',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lrm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lsm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lto',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lts',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'lwg',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'nle',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'nyd',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    luy: {
                        _desired: 'rag',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    lv: {
                        _desired: 'ltg',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'bhr',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'bjq',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'bmm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'bzc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'msh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'skg',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'tdx',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'tkg',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'txy',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'xmv',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mg: {
                        _desired: 'xmw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    mn: {
                        _desired: 'mvf',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'bjn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'btj',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'bve',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'bvu',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'coa',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'dup',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'hji',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'id',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'jak',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'jax',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'kvb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'kvr',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'kxd',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'lce',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'lcf',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'liw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'max',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'meo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'mfa',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'mfb',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'min',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'mqg',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'msi',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'mui',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'orn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'ors',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'pel',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'pse',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'tmw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'urk',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'vkk',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'vkt',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'xmm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'zlm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ms: {
                        _desired: 'zmi',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ne: {
                        _desired: 'dty',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    om: {
                        _desired: 'gax',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    om: {
                        _desired: 'hae',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    om: {
                        _desired: 'orc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    or: {
                        _desired: 'spv',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ps: {
                        _desired: 'pbt',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    ps: {
                        _desired: 'pst',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qub',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qud',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'quf',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qug',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'quh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'quk',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qul',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qup',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qur',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qus',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'quw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qux',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'quy',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qva',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qve',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvi',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvj',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvl',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvm',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvp',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvs',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qvz',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qwa',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qwc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qwh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qws',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxa',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxl',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxp',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxr',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxt',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxu',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    qu: {
                        _desired: 'qxw',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    sc: {
                        _desired: 'sdc',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    sc: {
                        _desired: 'sdn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    sc: {
                        _desired: 'sro',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    sq: {
                        _desired: 'aae',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    sq: {
                        _desired: 'aat',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    sq: {
                        _desired: 'aln',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    syr: {
                        _desired: 'aii',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    uz: {
                        _desired: 'uzs',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    yi: {
                        _desired: 'yih',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'cdo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'cjy',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'cpx',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'czh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'czo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'gan',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'hak',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'hsn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'lzh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'mnp',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'nan',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'wuu',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    zh: {
                        _desired: 'yue',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    '*': {
                        _desired: '*',
                        _distance: '80'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'am-Ethi',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'ru-Cyrl': {
                        _desired: 'az-Latn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'bn-Beng',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'zh-Hans': {
                        _desired: 'bo-Tibt',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'ru-Cyrl': {
                        _desired: 'hy-Armn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ka-Geor',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'km-Khmr',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'kn-Knda',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'lo-Laoo',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ml-Mlym',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'my-Mymr',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ne-Deva',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'or-Orya',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'pa-Guru',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ps-Arab',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'sd-Arab',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'si-Sinh',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ta-Taml',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'te-Telu',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ti-Ethi',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'ru-Cyrl': {
                        _desired: 'tk-Latn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'ur-Arab',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'ru-Cyrl': {
                        _desired: 'uz-Latn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'en-Latn': {
                        _desired: 'yi-Hebr',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'sr-Cyrl': {
                        _desired: 'sr-Latn',
                        _distance: '5'
                    }
                },
                {
                    'zh-Hans': {
                        _desired: 'za-Latn',
                        _distance: '10',
                        _oneway: 'true'
                    }
                },
                {
                    'zh-Hans': {
                        _desired: 'zh-Hani',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'zh-Hant': {
                        _desired: 'zh-Hani',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'ar-Arab': {
                        _desired: 'ar-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'bn-Beng': {
                        _desired: 'bn-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'gu-Gujr': {
                        _desired: 'gu-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'hi-Deva': {
                        _desired: 'hi-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'kn-Knda': {
                        _desired: 'kn-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'ml-Mlym': {
                        _desired: 'ml-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'mr-Deva': {
                        _desired: 'mr-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'ta-Taml': {
                        _desired: 'ta-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'te-Telu': {
                        _desired: 'te-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'zh-Hans': {
                        _desired: 'zh-Latn',
                        _distance: '20',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Jpan': {
                        _desired: 'ja-Latn',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Jpan': {
                        _desired: 'ja-Hani',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Jpan': {
                        _desired: 'ja-Hira',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Jpan': {
                        _desired: 'ja-Kana',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Jpan': {
                        _desired: 'ja-Hrkt',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Hrkt': {
                        _desired: 'ja-Hira',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ja-Hrkt': {
                        _desired: 'ja-Kana',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ko-Kore': {
                        _desired: 'ko-Hani',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ko-Kore': {
                        _desired: 'ko-Hang',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ko-Kore': {
                        _desired: 'ko-Jamo',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    'ko-Hang': {
                        _desired: 'ko-Jamo',
                        _distance: '5',
                        _oneway: 'true'
                    }
                },
                {
                    '*-*': {
                        _desired: '*-*',
                        _distance: '50'
                    }
                },
                {
                    'ar-*-$maghreb': {
                        _desired: 'ar-*-$maghreb',
                        _distance: '4'
                    }
                },
                {
                    'ar-*-$!maghreb': {
                        _desired: 'ar-*-$!maghreb',
                        _distance: '4'
                    }
                },
                {
                    'ar-*-*': {
                        _desired: 'ar-*-*',
                        _distance: '5'
                    }
                },
                {
                    'en-*-$enUS': {
                        _desired: 'en-*-$enUS',
                        _distance: '4'
                    }
                },
                {
                    'en-*-GB': {
                        _desired: 'en-*-$!enUS',
                        _distance: '3'
                    }
                },
                {
                    'en-*-$!enUS': {
                        _desired: 'en-*-$!enUS',
                        _distance: '4'
                    }
                },
                {
                    'en-*-*': {
                        _desired: 'en-*-*',
                        _distance: '5'
                    }
                },
                {
                    'es-*-$americas': {
                        _desired: 'es-*-$americas',
                        _distance: '4'
                    }
                },
                {
                    'es-*-$!americas': {
                        _desired: 'es-*-$!americas',
                        _distance: '4'
                    }
                },
                {
                    'es-*-*': {
                        _desired: 'es-*-*',
                        _distance: '5'
                    }
                },
                {
                    'pt-*-$americas': {
                        _desired: 'pt-*-$americas',
                        _distance: '4'
                    }
                },
                {
                    'pt-*-$!americas': {
                        _desired: 'pt-*-$!americas',
                        _distance: '4'
                    }
                },
                {
                    'pt-*-*': {
                        _desired: 'pt-*-*',
                        _distance: '5'
                    }
                },
                {
                    'zh-Hant-$cnsar': {
                        _desired: 'zh-Hant-$cnsar',
                        _distance: '4'
                    }
                },
                {
                    'zh-Hant-$!cnsar': {
                        _desired: 'zh-Hant-$!cnsar',
                        _distance: '4'
                    }
                },
                {
                    'zh-Hant-*': {
                        _desired: 'zh-Hant-*',
                        _distance: '5'
                    }
                },
                {
                    '*-*-*': {
                        _desired: '*-*-*',
                        _distance: '4'
                    }
                }
            ]
        }
    }
};
module.exports["data"] = $1358d37e8935a2f6$export$4051a07651545597;

});

parcelRegister("poqQX", function(module, exports) {
// This file is generated from regions-gen.ts
var $04c5499f8cc47d78$export$6b408984b31c1b30 = {
    "001": [
        "001",
        "001-status-grouping",
        "002",
        "005",
        "009",
        "011",
        "013",
        "014",
        "015",
        "017",
        "018",
        "019",
        "021",
        "029",
        "030",
        "034",
        "035",
        "039",
        "053",
        "054",
        "057",
        "061",
        "142",
        "143",
        "145",
        "150",
        "151",
        "154",
        "155",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BV",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CP",
        "CQ",
        "CR",
        "CU",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DG",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EA",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "EU",
        "EZ",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GG",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GS",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HM",
        "HN",
        "HR",
        "HT",
        "HU",
        "IC",
        "ID",
        "IE",
        "IL",
        "IM",
        "IN",
        "IO",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JE",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "QO",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SY",
        "SZ",
        "TA",
        "TC",
        "TD",
        "TF",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UA",
        "UG",
        "UM",
        "UN",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VE",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "XK",
        "YE",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "002": [
        "002",
        "002-status-grouping",
        "011",
        "014",
        "015",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EA",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IC",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "003": [
        "003",
        "013",
        "021",
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    "005": [
        "005",
        "AR",
        "BO",
        "BR",
        "BV",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GS",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    "009": [
        "009",
        "053",
        "054",
        "057",
        "061",
        "AC",
        "AQ",
        "AS",
        "AU",
        "CC",
        "CK",
        "CP",
        "CX",
        "DG",
        "FJ",
        "FM",
        "GU",
        "HM",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PN",
        "PW",
        "QO",
        "SB",
        "TA",
        "TK",
        "TO",
        "TV",
        "UM",
        "VU",
        "WF",
        "WS"
    ],
    "011": [
        "011",
        "BF",
        "BJ",
        "CI",
        "CV",
        "GH",
        "GM",
        "GN",
        "GW",
        "LR",
        "ML",
        "MR",
        "NE",
        "NG",
        "SH",
        "SL",
        "SN",
        "TG"
    ],
    "013": [
        "013",
        "BZ",
        "CR",
        "GT",
        "HN",
        "MX",
        "NI",
        "PA",
        "SV"
    ],
    "014": [
        "014",
        "BI",
        "DJ",
        "ER",
        "ET",
        "IO",
        "KE",
        "KM",
        "MG",
        "MU",
        "MW",
        "MZ",
        "RE",
        "RW",
        "SC",
        "SO",
        "SS",
        "TF",
        "TZ",
        "UG",
        "YT",
        "ZM",
        "ZW"
    ],
    "015": [
        "015",
        "DZ",
        "EA",
        "EG",
        "EH",
        "IC",
        "LY",
        "MA",
        "SD",
        "TN"
    ],
    "017": [
        "017",
        "AO",
        "CD",
        "CF",
        "CG",
        "CM",
        "GA",
        "GQ",
        "ST",
        "TD"
    ],
    "018": [
        "018",
        "BW",
        "LS",
        "NA",
        "SZ",
        "ZA"
    ],
    "019": [
        "003",
        "005",
        "013",
        "019",
        "019-status-grouping",
        "021",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BM",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CA",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GL",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PM",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "021": [
        "021",
        "BM",
        "CA",
        "GL",
        "PM",
        "US"
    ],
    "029": [
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BQ",
        "BS",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GP",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "PR",
        "SX",
        "TC",
        "TT",
        "VC",
        "VG",
        "VI"
    ],
    "030": [
        "030",
        "CN",
        "HK",
        "JP",
        "KP",
        "KR",
        "MN",
        "MO",
        "TW"
    ],
    "034": [
        "034",
        "AF",
        "BD",
        "BT",
        "IN",
        "IR",
        "LK",
        "MV",
        "NP",
        "PK"
    ],
    "035": [
        "035",
        "BN",
        "ID",
        "KH",
        "LA",
        "MM",
        "MY",
        "PH",
        "SG",
        "TH",
        "TL",
        "VN"
    ],
    "039": [
        "039",
        "AD",
        "AL",
        "BA",
        "ES",
        "GI",
        "GR",
        "HR",
        "IT",
        "ME",
        "MK",
        "MT",
        "PT",
        "RS",
        "SI",
        "SM",
        "VA",
        "XK"
    ],
    "053": [
        "053",
        "AU",
        "CC",
        "CX",
        "HM",
        "NF",
        "NZ"
    ],
    "054": [
        "054",
        "FJ",
        "NC",
        "PG",
        "SB",
        "VU"
    ],
    "057": [
        "057",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NR",
        "PW",
        "UM"
    ],
    "061": [
        "061",
        "AS",
        "CK",
        "NU",
        "PF",
        "PN",
        "TK",
        "TO",
        "TV",
        "WF",
        "WS"
    ],
    "142": [
        "030",
        "034",
        "035",
        "142",
        "143",
        "145",
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CN",
        "CY",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    "143": [
        "143",
        "KG",
        "KZ",
        "TJ",
        "TM",
        "UZ"
    ],
    "145": [
        "145",
        "AE",
        "AM",
        "AZ",
        "BH",
        "CY",
        "GE",
        "IL",
        "IQ",
        "JO",
        "KW",
        "LB",
        "OM",
        "PS",
        "QA",
        "SA",
        "SY",
        "TR",
        "YE"
    ],
    "150": [
        "039",
        "150",
        "151",
        "154",
        "155",
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CQ",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    "151": [
        "151",
        "BG",
        "BY",
        "CZ",
        "HU",
        "MD",
        "PL",
        "RO",
        "RU",
        "SK",
        "UA"
    ],
    "154": [
        "154",
        "AX",
        "CQ",
        "DK",
        "EE",
        "FI",
        "FO",
        "GB",
        "GG",
        "IE",
        "IM",
        "IS",
        "JE",
        "LT",
        "LV",
        "NO",
        "SE",
        "SJ"
    ],
    "155": [
        "155",
        "AT",
        "BE",
        "CH",
        "DE",
        "FR",
        "LI",
        "LU",
        "MC",
        "NL"
    ],
    "202": [
        "011",
        "014",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "419": [
        "005",
        "013",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "EU": [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "EU",
        "FI",
        "FR",
        "GR",
        "HR",
        "HU",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SE",
        "SI",
        "SK"
    ],
    "EZ": [
        "AT",
        "BE",
        "CY",
        "DE",
        "EE",
        "ES",
        "EZ",
        "FI",
        "FR",
        "GR",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PT",
        "SI",
        "SK"
    ],
    "QO": [
        "AC",
        "AQ",
        "CP",
        "DG",
        "QO",
        "TA"
    ],
    "UN": [
        "AD",
        "AE",
        "AF",
        "AG",
        "AL",
        "AM",
        "AO",
        "AR",
        "AT",
        "AU",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BN",
        "BO",
        "BR",
        "BS",
        "BT",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CU",
        "CV",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FM",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GR",
        "GT",
        "GW",
        "GY",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MR",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NE",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PG",
        "PH",
        "PK",
        "PL",
        "PT",
        "PW",
        "PY",
        "QA",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SI",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SY",
        "SZ",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TZ",
        "UA",
        "UG",
        "UN",
        "US",
        "UY",
        "UZ",
        "VC",
        "VE",
        "VN",
        "VU",
        "WS",
        "YE",
        "ZA",
        "ZM",
        "ZW"
    ]
};
module.exports["regions"] = $04c5499f8cc47d78$export$6b408984b31c1b30;

});


$parcel$global.rlb("5zWKA")
//# sourceMappingURL=render.3d740139.js.map
